/*** IMPORTS FROM imports-loader ***/
var define = false;
(function() {

/* eslint no-undef: 0 */
/* eslint no-unused-vars: 0 */
/* eslint no-redeclare: 0 */
var DealerNet = require('../../../../api');
var Handlebars = require('handlebars');
var prevent_checkout = false;
window.recentNewsInitiated = false;
window.recentNewsInitiating = false;

var csrfToken = $('[name="csrfmiddlewaretoken"]').attr('value');
window.wwwApi = new DealerNet.Client(window.appConfig, csrfToken);

//Functions
function productBlockInstall()
{
    if($(".product-block").length)
    {
        $(".product-block").not($(".lightbox .product-block")).removeAttr('style');
        //Project Blocks Remove Margin Right
        var containerWidth = $(".product-block:eq(0)").parent().parent()[0].getBoundingClientRect().width - parseFloat($(".product-block:eq(0)").parent().parent().css("padding-left")) - parseFloat($(".product-block:eq(0)").parent().parent().css("padding-right"));
        var productBlockWidth = parseFloat($(".product-block:eq(0)").outerWidth()) + parseFloat($(".product-block:eq(0)").css("margin-right").replace(/[^-\d.]/g, ''));

        var eqSelector = Math.floor(containerWidth/productBlockWidth);

        //Test to make sure that if we apply the margin the eqSelector will not change
        var potentialPBTotalWidth = parseFloat(productBlockWidth*(eqSelector+1)) - parseFloat($(".product-block:eq(0)").css("margin-right"));
        if(potentialPBTotalWidth <= containerWidth)
        {
            eqSelector++;
        }


        var currentPB = 1;
        $(".product-block").not($(".lightbox .product-block")).each(function( index ) {
            if( currentPB % eqSelector === 0 ) {
                $(this).css("margin-right","0");
            }
            currentPB++;		
        });
    }
}

function localeString(x, sep, grp) {
    var sx = (''+x).split('.'), s = '', i, j;
    sep || (sep = ','); // default seperator
    grp || grp === 0 || (grp = 3); // default grouping
    i = sx[0].length;
    while (i > grp) {
        j = i - grp;
        s = sep + sx[0].slice(j, i) + s;
        i = j;
    }
    s = sx[0].slice(0, i) + s;
    sx[0] = s;
    return sx.join('.')
}


function ProductBlockHeightStandardise()
{	
    //Default is 42
    //Highest is 72

    //Increase all to 72
    //Incrase Product Block height by differnce

    h4_largest_height = 0;
    new_block_height = 0;

    $(".product-block h4").each(function(){
        if($(this).height() > h4_largest_height)
        {
            h4_largest_height = $(this).height();

        }

    });

    $(".product-block h4").height(h4_largest_height);




    // h4_default_height = 42
    // h4_largest_height = 0

    // if(window.product_block_inital_height == undefined)
    // {
    // 	window.product_block_inital_height = $(".product-block:first-of-type").height()
    // }
    

    // $(".info").each(function(){
    // 	if($(this).find('h4').height() > h4_largest_height)
    // 	{	
    // 		h4_largest_height = $(this).find('h4').height()
    // 	}
    // });

    // product_block_height = window.product_block_inital_height + (h4_largest_height - h4_default_height); 
    // $(".info h4").height(h4_largest_height);
    // $(".product-block").height(product_block_height)
}




//AJAX FUNCTIONS

function ajaxCartLineQty()
{
    window.wwwApi.cart.getCart().then(response => {
        if(response.total_quantity == 0)
        {
            $(".cart-button").show();
            $(".cart-button span").text('Your Cart is Empty');
            $('.cart-button').addClass('empty');
            $('.mobile-cart-button').addClass('empty')
        }
        else {
            $(".cart-button").show();
            $('.cart-button').removeClass('empty');
            $('.mobile-cart-button').removeClass('empty');
            if(response.total_quantity == 1)
            {
                $(".cart-button span").text('1 Item in Your Cart');
            }
            else
            {
                $(".cart-button span").text(response.total_quantity +' Items in Your Cart');
            }
        }
        $('.mobile-cart-button span').text(response.total_quantity);
        
        LCPushCart(response);
    });
}

function ajaxAddToCart()
{

    var form = $("#add-to-cart-form");
    var formData = 'action=add_to_cart&' + form.serialize();

    if($(".lightbox.quick-add-form").length)
    {
        lightbox_variant = '.lightbox.quick-add-form';
    }
    else if($(".lightbox.ajax-cat-cart-add").length)
    {
        lightbox_variant = '.lightbox.ajax-cat-cart-add';
    }
    else
    {
        lightbox_variant = '.lightbox.qty';
    }

    $.ajax({
    type: 'POST',
    url: form.attr('data-ajax-action'),
    data: formData,
    timeout: 20000,
    beforeSend: function () {
        $(lightbox_variant+" p").hide();
        $(lightbox_variant+" form").hide();
        $(lightbox_variant+" h6").text('Processing');
        $("#fill-prod-variant").hide();
        $("#fill-prod-variant-selector").hide();
        $(".add-loading-icon").show();
        $(".add-error-icon").hide();
        $(lightbox_variant+" .manual-add-text").hide();

    }
    }).done(function(response) {

        if(response.result == 'success')
        {
            if(lightbox_variant == ".lightbox.ajax-cat-cart-add")
            {
                $(".add-loading-icon").hide();

                if(window.display_backorder)
                {
                    $(lightbox_variant+" h6").text('Successfully added to cart');

                    $(lightbox_variant+" #backorder-warning-text").show();
                    $("#backorder-close").show();

                    if(window.backorder_eta)
                    {	
                        $("#back-order-arrival-noeta").hide();
                        $("#back-order-arrival-eta").show();
                        $("#back-order-arrival-eta strong").text((window.backorder_eta.getDate()) + ' ' + window.backorder_eta.toLocaleString("en-au", { month: "long" }));
                        $("#back-order-arrival-date").show();
                    }
                    else
                    {
                        $("#back-order-arrival-eta").hide();
                        $("#back-order-arrival-noeta").show();
                    }

                    pop_up_fade_out_time = 5000;

                }
                else
                {
                    $("#fill-prod-variant").hide();
                    $("#fill-prod-variant-selector").hide();
                    $(".add-to-cart-form").hide();

                    ajaxCartLineQty();

                    $(lightbox_variant).attr('id', 'added-to-cart-lb');
                    $(lightbox_variant+" h6").text("Successfully added to cart");
                    $(lightbox_variant+" #added-to-cart-item").show();
                    $(lightbox_variant+" #added-to-cart-item-image").show();

                    if($("#product-qty").val() == 1)
                    {
                        $(lightbox_variant+" #added-to-cart-item span").text($("#product-qty").val() + 'x ' + $('.custom-field-label.active').text() + ' ' + $('#fill-prod-name').text());
                    }
                    else
                    {
                        $(lightbox_variant+" #added-to-cart-item span").text($("#product-qty").val() + 'x ' + $('.custom-field-label.active').text() + ' ' + $('#fill-prod-name').text());
                    }

                    
                    $(lightbox_variant+" #add-to-cart-buttons").show();

                    pop_up_fade_out_time = 5000;

                }

                window.setTimeout(function(){
                    //Check to make sure lightbox hasn't already been reset 
                    if($(lightbox_variant+" h6").text() !== 'Choose Quantity')
                    {
                        $(".lightbox-cover").fadeOut();
                        $(".lightbox").fadeOut();

                        if($(".wizard-section").length)
                        {
                            location.reload();
                        }

                        window.setTimeout(function(){resetAddToCartForm()},500);
                    }
                },pop_up_fade_out_time);
            }
            else
            {
                $(".add-loading-icon").hide();

                if(window.display_backorder)
                {
                    $(lightbox_variant+" h6").text('Successfully added to cart');
                    $(lightbox_variant+" #backorder-warning-text").show();
                    $("#backorder-close").show();

                    if(window.backorder_eta)
                    {	
                        $("#back-order-arrival-noeta").hide();
                        $("#back-order-arrival-eta").show();
                        $("#back-order-arrival-eta strong").text((window.backorder_eta.getDate()) + ' ' + window.backorder_eta.toLocaleString("en-au", { month: "long" }));
                        $("#back-order-arrival-date").show();
                    }
                    else
                    {
                        $("#back-order-arrival-eta").hide();
                        $("#back-order-arrival-noeta").show();
                    }

                    pop_up_fade_out_time = 5000;
                    
                }
                else
                {

                    $(lightbox_variant).attr('id', 'added-to-cart-lb');
                    $(lightbox_variant+" h6").text("Successfully added to cart");
                    $(lightbox_variant+" #added-to-cart-item").show();
                    $(lightbox_variant+" #added-to-cart-item img").attr('src', $(".new-product-image:visible").first().attr('src'));
                    $(lightbox_variant+" #added-to-cart-item-image").show();

                    if($("#product-qty").val() == 1)
                    {
                        $(lightbox_variant+" #added-to-cart-item span").text($("#product-qty").val() + 'x ' + $('.qty-variant').text() + ' ' + $('#product-title').text());
                    }
                    else
                    {
                        $(lightbox_variant+" #added-to-cart-item span").text($("#product-qty").val() + 'x ' + $('.qty-variant').text() + ' ' + $('#product-title').text());
                    }

                    
                    $(lightbox_variant+" #add-to-cart-buttons").show();

                    pop_up_fade_out_time = 5000;
                    
                }

                window.setTimeout(function(){
                    //Check to make sure lightbox hasn't already been reset 
                    if($(lightbox_variant+" h6").text() !== 'Choose Quantity')
                    {
                        $(".lightbox-cover").fadeOut();
                        $(".lightbox").fadeOut();
                        window.setTimeout(function(){resetAddToCartForm()},500);
                    }
                },pop_up_fade_out_time);
                

                ajaxMiniCart();
                ajaxCartLineQty();

                // TOUR / JOYRIDE COMMENTED SCRIPTS
                /*
                if($('.joyride-tip-content')) {
                    $.fn.joyride('destroy')
                }
                $('#InterdynJoyrideTour-mini-cart').joyride({
                    autoStart : true
                });
                */
            }

            // If Backorder
            if($(".backorder-warning").hasClass("open"))
            {	
                $(".lightbox.backorder-warning p").hide();
                $(".lightbox.backorder-warning button").hide();
                $(".lightbox.backorder-warning").removeClass("open");

                if($("#product-qty").val() == 1)
                {	
                    if(lightbox_variant == ".lightbox.ajax-cat-cart-add"){$(".lightbox.backorder-warning h6").text($("#product-qty").val() + 'x ' + $('.custom-field-label.active').text() + ' ' + $('#fill-prod-name').text() +' Added to Cart');}
                    else{$(".lightbox.backorder-warning h6").text($("#product-qty").val() + 'x ' + $('.qty-variant').text() + ' ' + $('#product-title').text() +' Added to Cart');}
                    
                }
                else
                {	
                    if(lightbox_variant == ".lightbox.ajax-cat-cart-add"){$(".lightbox.backorder-warning h6").text($("#product-qty").val() + 'x ' + $('.custom-field-label.active').text() + ' ' + $('#fill-prod-name').text() +'s Added to Cart');}
                    else{$(".lightbox.backorder-warning h6").text($("#product-qty").val() + 'x ' + $('.qty-variant').text() + ' ' + $('#product-title').text() +'s Added to Cart');}
                }
            }

        }
        //FAILS
        else
        {
            $(".add-loading-icon").hide();
            $(".add-error-icon").show();
            $(".qty-selector").hide();
            $(lightbox_variant+" button").hide();
            $(lightbox_variant+" .manual-add").show();
            $(lightbox_variant+" form").show();
            $(lightbox_variant+" h6").text("Couldn't add item to cart.");
        }
    }).fail(function(jqXHR) {
        if(jqXHR.status == 404 | jqXHR.status == 405 | jqXHR.status == 500 | jqXHR.status == 501 | jqXHR.status == 502 | jqXHR.status == 503 | jqXHR.status == 504 | jqXHR.status == 505 )
        {
            $(lightbox_variant+" form").submit();
        }
        else
        {
            $(".add-loading-icon").hide();
            $(".add-error-icon").show();
            $(".qty-selector").hide();
            $(lightbox_variant+" button").hide();
            $(lightbox_variant+" .manual-add").show();
            $(lightbox_variant+" form").show();
            $(lightbox_variant+" h6").text("Couldn't add item to cart.");
        }

    });
}

function resetAddToCartForm()
{
    $(".add-loading-icon").hide();
    $(".add-error-icon").hide();
    $(".lightbox.qty p").show();
    $(".qty-selector").show();
    $(".lightbox.qty button").show();
    $(".lightbox.qty .manual-add").hide();
    $(".lightbox.qty form").show();
    $(".lightbox.qty h6").text('Choose Quantity');
    $(".lightbox.qty form input[name='qty']").val('1');
    $(".lightbox.qty form input[name='quantity']").val('1');
    $("#backorder-warning-text, #back-order-arrival-eta, #back-order-arrival-noeta, #backorder-close").hide();

    $(".lightbox.qty").attr('id', '');
    $("#add-to-cart-buttons, #added-to-cart-item-image, #added-to-cart-item").hide();

    //AJAX CAT VERSION
    $(".lightbox.ajax-cat-cart-add p:first-of-type, .lightbox.ajax-cat-cart-add p:nth-of-type(2), .lightbox.ajax-cat-cart-add p:nth-of-type(3)").show();
    $(".lightbox.ajax-cat-cart-add form").show();
    $("#fill-prod-variant").show();
    $("#fill-prod-variant-selector").show();
    $(".lightbox.ajax-cat-cart-add form button").show();
    $(".lightbox.ajax-cat-cart-add .manual-add").hide();
    $(".lightbox.ajax-cat-cart-add h6").text('Choose Quantity');
    $(".lightbox.ajax-cat-cart-add form input[name='qty']").val('1');
    $(".lightbox.ajax-cat-cart-add form input[name='quantity']").val('1');
    $(".lightbox.ajax-cat-cart-add form input#id_country_variant").val('');
    $(".lightbox.ajax-cat-cart-add").attr('id', '');

}

function LCVariablePush(response) {
    var custom_variables = [];

    custom_variables.push(window.appConfig.LC_default_params[0]);
    custom_variables.push(window.appConfig.LC_default_params[1]);

    if(response.results.length > 0)
    {

        

        // OPTION TO IMPLEMENT ONCE BREAK WORKS
        // var cart_items = '';
        // for (var i = response.lc_cart.length - 1; i >= 0; i--) {
        // 	cart_items += response.lc_cart[i].item + ' - ' + response.lc_cart[i].qty + '\n';
        // }
        // custom_variables.push({name: 'Cart', value: cart_items})


        //OPTION TO SET EACH LINE AS A NEW VARIABLE
        custom_variables.push({name:'CART', value: ':'});

        for (var i = response.results.length - 1; i >= 0; i--) {
            custom_variables.push({name: response.results[i].country_variant, value: response.results[i].quantity});
        }
        
    }

    else
    {
        custom_variables.push({name:'CART', value: 'EMPTY'})
    }


    LC_API.set_custom_variables(custom_variables);
}

function LCPushCart(response)
{
    if (response) {
        LCVariablePush(response);
    } else {
        window.wwwApi.cart.getCart().then(LCVariablePush);
    }
}


var LC_API = LC_API || {
    set_custom_variables: function() {
        return;
    }
};
LC_API.on_after_load = function()
{
    LCPushCart();
};

function ajaxMiniCart()
{
    $(".mini-cart .row").remove();
    $(".mini-cart .btn").remove();
    $(".mini-cart-loader").show();

    window.wwwApi.cart.getCart(5).then(response => {

        if(response.count == 0)
        {
            $(".mini-cart").hide();	
        }
        else
        {
            $(".mini-cart").show();	
            $(".mini-cart .row").remove();
            $(".mini-cart .btn").remove();
            $(".mini-cart-loader").hide();

            for (var i = response.results.length - 1; i >= 0; i--) {
                    
                    item = '<div class="row"><div class="col-xs-12"><div class="mini-cart-item"><span class="mini-qty">'+response.results[i].quantity+'x&nbsp;</span><span class="title">'+response.results[i].country_variant+'</span></div></div></div>';
                    $(".mini-cart h6").after(item);
                }

            var extra_items_amount = response.count - response.results.length;

            if(extra_items_amount == 1)
            {
                extra_items = '<div class="row"><div class="col-xs-12"><div class="mini-cart-item"><span class="mini-qty">'+ extra_items_amount +' more item in your cart</span></div></div></div>';
                $(".mini-cart .row").last().after(extra_items);
            }
            else if (extra_items_amount > 0)
            {
                extra_items = '<div class="row"><div class="col-xs-12"><div class="mini-cart-item"><span class="mini-qty">'+ extra_items_amount +' more items in your cart</span></div></div></div>';
                $(".mini-cart .row").last().after(extra_items);
            }


            $(".mini-cart .row").last().after('<button type="submit" class="btn btn-primary btn-small btn-block" id="mini-cart-button-joyride"><i class="fa fa-shopping-cart"></i> Full Cart &amp; Checkout</button>');
        }
    });
}


// TEMP FUNCTION FOR GETTING NEW DISCOUNTS

// Firstly we are going to define window variable for storing variant information so we make the user choice operate
window.ICDS_offer_variable_info = {};
window.ICDS_total_info = {};
window.ICDS_cart_info = {};

function update_cart_totals()
{
    cart_post_total = Number(window.ICDS_cart_info['total_pre_ex']);

    for(var offer_id in window.ICDS_cart_info['discounts_applied']) {
      cart_post_total -= window.ICDS_cart_info['discounts_applied'][offer_id];
    }


    $(".cart-totals .subtotal strong").html("$"+cart_post_total.toFixed(2));
    cart_total_after_tax = ((cart_post_total.toFixed(2)) * parseFloat(window.ICDS_cart_info['tax_rate']).toFixed(2) / 100 ).toFixed(2);
    $(".cart-totals .GST strong").html("$"+cart_total_after_tax);
    cart_post_total_inc = (Number(cart_post_total.toFixed(2)) + Number(cart_total_after_tax)).toFixed(2);
    $(".cart-totals .total strong").html("$"+cart_post_total_inc);

    if(window.freight_popup_required_value)
    {
        window.freight_popup_value = window.freight_popup_required_value.toFixed(2);
    }
    else
    {
        window.freight_popup_value = (2000 - cart_post_total).toFixed(2);
    }
    

    if(window.freight_popup_value <= 0)
    {
        window.show_freight_popup = false;
    }
}

function updateICDSCartDiscounts(response) {
    const discountsResponse = response.discounts;
    if (discountsResponse.pending === true) {
        return;
    }

    // Clear previous variable
    window.ICDS_offer_variable_info = {};
    window.ICDS_total_info = {};
    window.ICDS_cart_info = {};

    $(".ICDS-offer").remove();
    $(".ICDS-p-offer").remove();

    $(".IDCS-discount-loader").hide();

    show_offers_div = false;

    if(discountsResponse.cart)
    {
        cart = discountsResponse.cart;

        window.ICDS_cart_info['total_pre_ex'] = cart['total_pre_ex'];
        window.ICDS_cart_info['tax_rate'] = cart['tax_rate'];
        window.ICDS_cart_info['discounts_applied'] = {}; //{id:value}
    }

    if(discountsResponse.offers && discountsResponse.offers.length > 0)
    {	
        offers = discountsResponse.offers;
        show_offers_div = true;

        for (var i = offers.length - 1; i >= 0; i--) {

            offer_append_var = '<div class="ICDS-offer" id="offer-'+offers[i]['offer_id']+'">';
            offer_append_var += '<h6 class="offer-title">'+offers[i]['offer_name']+'</h6>';

            offer_append_var += '<div class="offer-value"><span>Discount Value: </span><strong>';

            // Define var for total_appended

            window.ICDS_total_info[offers[i]['offer_id']] = {};

            total_append = false;
            // Work out which offer total to append

            if(offers[i]['user_choice'])
            {
                if(offers[i]['user_choice'] == 'value' && offers[i]['offer_value_option']){total_append = 'value';}
                else if(offers[i]['user_choice'] == 'terms' && offers[i]['offer_terms_option']){total_append = 'terms';}
                else if(offers[i]['user_choice'] == 'split' && offers[i]['offer_split_option']){total_append = 'split';}
            }
            else
            {
                if(offers[i]['offer_terms_option']){total_append = 'terms'; default_choice = 'terms'}
                else if(offers[i]['offer_split_option']){total_append = 'split'; default_choice = 'split'}
                else if(offers[i]['offer_value_option']){total_append = 'value'; default_choice = 'value'}
            }

            if(offers[i]['offer_value_option'])
            {	
                if(total_append == 'value')
                {
                    offer_append_var += '$'+parseFloat(offers[i]['offer_total_value']).toFixed(2);
                    window.ICDS_cart_info['discounts_applied'][offers[i]['offer_id']] = offers[i]['offer_total_value'];
                }
            
                window.ICDS_total_info[offers[i]['offer_id']]['offer_total_value'] = offers[i]['offer_total_value'];
            }

            if(offers[i]['offer_terms_option'])
            {
                if(total_append == 'terms')
                {
                    offer_append_var += offers[i]['offer_total_terms']+' days extended terms';
                    window.ICDS_cart_info['discounts_applied'][offers[i]['offer_id']] = 0;
                }	

                window.ICDS_total_info[offers[i]['offer_id']]['offer_total_terms'] = offers[i]['offer_total_terms'];
            }

            if(offers[i]['offer_split_option'])
            {	
                if(total_append == 'split')
                {
                    offer_append_var += '$'+parseFloat(offers[i]['offer_split_value']).toFixed(2);
                    offer_append_var += ' and ' + offers[i]['offer_split_terms']+' days extended terms';
                    window.ICDS_cart_info['discounts_applied'][offers[i]['offer_id']] = offers[i]['offer_split_value'];
                }

                window.ICDS_total_info[offers[i]['offer_id']]['offer_split_value'] = offers[i]['offer_split_value'];
                window.ICDS_total_info[offers[i]['offer_id']]['offer_split_terms'] = offers[i]['offer_split_terms'];
            }

            offer_append_var += '</strong></div>';

            // If offer has the ability to choose terms

            offers_user_choice_show = 0;
            if(offers[i]['offer_value_option']){offers_user_choice_show += 1;}
            if(offers[i]['offer_terms_option']){offers_user_choice_show += 1;}
            if(offers[i]['offer_split_option']){offers_user_choice_show += 1;}

            if(offers_user_choice_show > 1)
            {
                offer_append_var += '<div class="offer-user-choice-container">';
                offer_append_var += '<p>Choose your benefit type:</p>';
                offer_append_var += '<form class="ICDS-user-choice-form">';

                    if(offers[i]['offer_value_option'])
                    {	

                        offer_append_var += '<input type="radio" value="value" name="'+offers[i]['offer_id']+'" id="'+offers[i]['offer_id']+'-value"';
                        
                        if(offers[i]['user_choice'])
                        {
                            if(offers[i]['user_choice'] == 'value')
                            {
                                offer_append_var += ' checked';
                            }
                        }
                        else if(default_choice == 'value')
                        {
                            offer_append_var += ' checked';
                        }

                        value_label = 'Value';
                        if(offers[i]['offer_value_percentage']){value_label = offers[i]['offer_value_percentage'];}

                        offer_append_var += '><label for="'+offers[i]['offer_id']+'-value">'+value_label+'</label>';

                    }
                    if(offers[i]['offer_terms_option'])
                    {	

                        offer_append_var += '<input type="radio" value="terms" name="'+offers[i]['offer_id']+'" id="'+offers[i]['offer_id']+'-terms"';

                        if(offers[i]['user_choice'])
                        {
                            if(offers[i]['user_choice'] == 'terms')
                            {
                                offer_append_var += ' checked';
                            }
                        }
                        else if(default_choice == 'terms')
                        {
                            offer_append_var += ' checked';
                        }

                        terms_label = 'Terms';
                        if(offers[i]['offer_total_terms']){terms_label = offers[i]['offer_total_terms'] + ' Extra Days';}
                        offer_append_var += '><label for="'+offers[i]['offer_id']+'-terms">'+terms_label+'</label>';
                    }

                    if(offers[i]['offer_split_option'])
                    {
                        offer_append_var += '<input type="radio" value="split" name="'+offers[i]['offer_id']+'" id="'+offers[i]['offer_id']+'-split"';

                        if(offers[i]['user_choice'])
                        {
                            if(offers[i]['user_choice'] == 'split')
                            {
                                offer_append_var += ' checked';
                            }
                        }
                        else if(default_choice == 'split')
                        {
                            offer_append_var += ' checked';
                        }

                        split_label = 'Split';
                        if(offers[i]['offer_split_percentage']){split_label = offers[i]['offer_split_percentage'] + ' + ' + offers[i]['offer_split_terms'] + ' Extra Days';}
                        offer_append_var += '><label for="'+offers[i]['offer_id']+'-split">'+split_label+'</label>';
                    }
                offer_append_var += '</form>';
                offer_append_var += '</div>';
            }
            

            if(offers[i]['offer_variants'].length > 0 || offers[i]['offer_condition_variants'].length > 0)
            {	

                offer_append_var += '<span class="offer-variants-toggle-button closed ovtb"><i class="fa fa-chevron-up"></i></span>';
                offer_append_var += '<span class="offer-variants-closed-heading ovtb">Click here to see items which this offer applies to</span>';
                offer_append_var += '<span class="offer-variants-open-heading ovtb">This offer applies to the following items</span>';
                
                offer_append_var += '<div class="offer-variants-container">';

                condition_variants = offers[i]['offer_condition_variants'];
                for (var ii = 0; ii < condition_variants.length; ii++) {

                    offer_append_var += '<span class="offer-variant">'+condition_variants[ii]['variant_qty']+'x '+condition_variants[ii]['line_name']+' <span class="orange-required">(required)</span></span>';

                }

                variants = offers[i]['offer_variants'];

                for (var ii = 0; ii < variants.length; ii++) {

                    // Start the append var
                    offer_append_var += '<span class="offer-variant" id="'+variants[ii]['country_variant_id']+'">'+variants[ii]['variant_qty']+'x '+variants[ii]['line_name']+':';

                    // Here we actually need to check which variant type to display by default so basically we just run through

                    if(offers[i]['offer_value_option'] && total_append == 'value')
                    {
                        // Discount Value
                        offer_append_var += '<span class="green-discount"> $'+parseFloat(variants[ii]['line_total_value']).toFixed(2);

                        if(variants[ii]['variant_qty'] > 1)
                        {
                            offer_append_var += ' <small class="discount-per-item">($'+variants[ii]['variant_value_discount_per_item']+' per item)</small>';
                        }

                        offer_append_var += '</span>';

                    }
                    else if(offers[i]['offer_terms_option'] && total_append == 'terms')
                    {
                        // Terms
                        
                        offer_append_var += '<span class="green-discount"> '+variants[ii]['variant_terms'] + ' days extended terms';
                        offer_append_var += '</span>';
                    }

                    else if(offers[i]['offer_split_option'] && total_append == 'split')
                    {
                        // Split
                        
                        // Discount Value
                        offer_append_var += '<span class="green-discount"> $'+parseFloat(variants[ii]['line_total_split_value']).toFixed(2);
                        if(variants[ii]['variant_qty'] > 1)
                        {
                            offer_append_var += ' <small class="discount-per-item">($'+variants[ii]['variant_split_value_discount']+' per item)</small>';
                        }

                        offer_append_var += ' & '+variants[ii]['variant_split_terms'] + ' days extended terms';
                        offer_append_var += '</span>';
                    }
                  

                    offer_append_var += '</span>';

                    // Get the info to append to the window.ICDS_offer_variable_info:

                    variant_info = {};

                    variant_info['qty'] = variants[ii]['variant_qty'];

                    if(offers[i]['offer_value_option'])
                    {
                        variant_info['value'] = variants[ii]['variant_value_discount_per_item'];
                        variant_info['line_total_value'] = variants[ii]['line_total_value'];
                    }

                    if(offers[i]['offer_terms_option'])
                    {
                        variant_info["terms"] = variants[ii]['variant_terms'];
                    }

                    if(offers[i]['offer_split_option'])
                    {
                        variant_info["split_discount"] = variants[ii]['variant_split_value_discount'];
                        variant_info["split_terms"] = variants[ii]['variant_split_terms'];
                        variant_info['line_total_split_value'] = variants[ii]['line_total_split_value'];
                    }

                    if(!(offers[i]['offer_id'] in window.ICDS_offer_variable_info))
                    {
                        window.ICDS_offer_variable_info[offers[i]['offer_id']] = {}
                    }

                    window.ICDS_offer_variable_info[offers[i]['offer_id']][variants[ii]['country_variant_id']] = variant_info
                }


                offer_append_var += '</div>';

            }

            offer_append_var += '</div>';

            $(".brand.ICDS h4:eq( 0 )").show();
            $(".brand.ICDS h4:eq( 0 )").after(offer_append_var);
            
        }
    }

    if(discountsResponse.freight_offer_variants && discountsResponse.freight_offer_variants.length > 0)
    {
        //Lets clear any currently appended offers
        $(".freight-discounts-title").remove();
        $(".freight-discounts-legend").remove();
        $(".ICDS-freight-variants-container").remove();

        show_offers_div = true;

        variants_append_var = '<span class="freight-discounts-title">The following items receive freight discounts:</span>';
        variants_append_var += '<span class="freight-discounts-legend"><i class="fa fa-home"></i> Denotes applicable to drop ship orders</span>';
        variants_append_var += '<div class="ICDS-freight-variants-container">';

        freight_variants = discountsResponse.freight_offer_variants;

        for (var i = freight_variants.length - 1; i >= 0; i--) {

            variants_append_var += '<span class="freight-variant">'+freight_variants[i]['line_name'];

            if(freight_variants[i]['item_freight_percentage_discount'] == 100)
            {
                variants_append_var += '<span class="green-discount">Free Freight</span>';
            }
            else
            {
                variants_append_var += '<span class="green-discount">'+freight_variants[i]['item_freight_percentage_discount']+'%';
            }

            if(freight_variants[i]['dropship'])
            {
                variants_append_var += ' <i class="freight-discount-dropshipable fa fa-home"></i>';
            }
            else
            {
                variants_append_var += ' <span class="freight-spacer"></span>';
            }

             variants_append_var += '</span>';
             variants_append_var += '</span>';

        }

        variants_append_var += '</div>';

        $(".brand.ICDS h4:eq( 2 )").show();
        $(".brand.ICDS h4:eq( 2 )").after(variants_append_var);

    }
    else if(discountsResponse.freight_constant)
    {
        //Lets clear any currently appended offers
        $(".freight-discounts-title").remove();
        $(".freight-discounts-legend").remove();
        $(".ICDS-freight-variants-container").remove();

        variants_append_var = '<div class="ICDS-freight-variants-container">';

        show_offers_div = true;
        if(discountsResponse.freight_constant.percentage_discount == 100)
        {
            variants_append_var += '<span class="freight-discounts-title">All items receive free freight';
        }
        else
        {
            variants_append_var += '<span class="freight-discounts-title">All items receive a '+discountsResponse.freight_constant.percentage_discount+'% freight discount';
        }
        
        if(discountsResponse.freight_constant.dropship) {
            variants_append_var += ' <small>(<strong>applies</strong> to direct-to-customer orders)</small></span>';
        } else {
            if (discountsResponse.freight_constant.dropship_percentage_discount > 0) {
                variants_append_var += ' for store delivery <small>(Direct-to-customer orders will receive a '+ discountsResponse.freight_constant.dropship_percentage_discount + '% freight discount)</small></span>';
            } else {
                variants_append_var += ' for store delivery <small>(<strong>does not</strong> apply to direct-to-customer orders)</small></span>';
            }
        }

        variants_append_var += '</div>';

        $(".brand.ICDS h4:eq( 2 )").show();
        $(".brand.ICDS h4:eq( 2 )").after(variants_append_var);

        window.show_freight_popup = false;
    }

    else
    {
        window.show_freight_popup = true;
        window.freight_popup_value = 0;
    }

    if(discountsResponse.partial_offers && discountsResponse.partial_offers.length > 0)
    {	
        offers = discountsResponse.partial_offers;

        show_offers_div = true;

        //Lets clear any currently appended offers
        

        for (var i = offers.length - 1; i >= 0; i--) {

            if(offers[i]['cart_display'])
            {
                
                offer_append_var = '<div class="ICDS-p-offer">';
                // REMOVE REMOVE REMOVE THIS LINE
                if('freight_offer' in offers[i])
                {
                    offer_append_var += '<a href="'+window.appConfig.urls.catalogue+'"><button>Continue Shopping</button></a>';
                }
                else
                {
                    offer_append_var += '<a href="'+offers[i]['url']+'"><button>Complete Offer</button></a>';
                }
                
                offer_append_var += '<h6 class="offer-title">'+offers[i]['offer_name']+'</h6>';
                offer_append_var += '<span class="offer-req">'+offers[i]['cart_requirement']+'</span>';
                offer_append_var += '</div>';

                $(".brand.ICDS h4:eq( 1 )").show();
                $(".brand.ICDS h4:eq( 1 )").after(offer_append_var);

            }

            if('freight_offer' in offers[i] && 'required_value' in offers[i]['requirements'])
            {
                window.freight_popup_required_value = offers[i]['requirements']['required_value'];
            }
            
        }

        // Add margin to heading
        $(".ICDS-offer").last().css('margin-bottom','20px');
    }
    


    if(show_offers_div)
    {
        
        // Add margin to headings
        if($('.ICDS-p-offer').length)
        {
            $(".ICDS-offer").last().css('margin-bottom','20px');

            if($(".ICDS-freight-variants-container").length)
            {
                $('.ICDS-p-offer').last().css('margin-bottom','20px');
            }
        }
        else
        {
            if($(".ICDS-freight-variants-container").length)
            {
                $('.ICDS-offer').last().css('margin-bottom','20px');
            }
        }


        $(".brand.ICDS").show();
    }
    else
    {
        $(".brand.ICDS").hide();
    }
    
    $("#checkout-joyride").prop('disabled', false).text("Checkout");

    update_cart_totals();
}

function ajaxICDS_cart_discounts(response)
{
    $(".IDCS-discount-loader").show();
    $(".ICDS h4").hide();
    $(".ICDS-offer").remove();
    $(".ICDS-p-offer").remove();
    $(".freight-discounts-title").remove();
    $(".freight-discounts-legend").remove();
    $(".ICDS-freight-variants-container").remove();

    // Disable the checkout button
    $("#checkout-joyride").prop('disabled', true).text("Calculating discounts...");


    if (response && !response.discounts.pending) {
        updateICDSCartDiscounts(response);
    } else {
        window.wwwApi.cart.getCart().then((loopResponse) => {
            if (loopResponse.discounts.pending) {
                const intervalID = setInterval(() => window.wwwApi.cart.getCart().then((loopResponse) => {
                    if (!loopResponse.discounts.pending) {
                        clearInterval(intervalID);
                    }
                    updateICDSCartDiscounts(loopResponse);
                }), 1000);
            } else {
                updateICDSCartDiscounts(loopResponse);
            }
        });
    }
}


function detectLocalStorage()
{
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}

window.recent_sales_fetch_count = 0;

function popupClosePosition()
{	
    // Pop Up Scripts
    if($("#popup-image").length)
    {
    
        // Calculate where the close button should be
        nautral_height = document.getElementById('popup-image').naturalHeight;
        nautral_width = document.getElementById('popup-image').naturalWidth;
        natural_ratio = nautral_width / nautral_height;
        current_height = document.getElementById('popup-image').height;
        current_width = document.getElementById('popup-image').width;
        current_ratio = current_width / current_height;


        if(nautral_height > current_height || nautral_width > current_width)
        {
            if(natural_ratio > current_ratio)
            {
                close_offset_top = -1 * ((current_width/natural_ratio) - current_height) / 2;
                close_offset_right = 0;
            }
            else
            {
                close_offset_top = 0;
                close_offset_right = -1 * ((current_height*natural_ratio) - current_width) / 2;
            }
        }
        else
        {
            close_offset_top = (current_height - nautral_height) / 2;
            close_offset_right = (current_width - nautral_width) / 2
        }


        $("#pop-up-close").css({"right":close_offset_right, "top":close_offset_top});
    }
}


$( document ).ready(function() {

    // Home Page Banner videos

    if($(".banner-2022").length)
    {

        function pausePlayBannerVideos(){

            let allVids = $(".banner-2022").find('.carousel-item');

            // Pause all
            allVids.each(function(index, el) {
              if (index !== 0) {
                if($(this).find('video')[0])
                {
                    $(this).find('video')[0].pause();
                }
                
              }
            });

            // Play current video
            if($(".banner-2022 .carousel-item.active").find('video')[0])
            {
                $(".banner-2022 .carousel-item.active").find('video')[0].currentTime = 0;
                $(".banner-2022 .carousel-item.active").find('video')[0].play();
            }
        }

        pausePlayBannerVideos();

        $(".banner-2022").on('slid.bs.carousel', function(ev) {

           pausePlayBannerVideos();

        });
    }
    




    popupClosePosition();

    $("#pop-up-cover, #pop-up-close").click(function(){

        $("#pop-up, #pop-up-cover").fadeOut();

        // If Iframe kill it
        setTimeout(function(){$("#pop-up iframe").remove()}, 600);

    });



    function recentSalesFadeOut()
    {	
        setTimeout(function ()
        {	
            if(!$(".recent-sale").is(":hover"))
            {
                $(".recent-sale").fadeOut(1000);
            }
            else
            {
                recentSalesFadeOut();
            }
        
        }, 10000);
        
    }

    function recentSalesRenderer(recent_sales_item)
    {
        $(".recent-sale").remove();

        function capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        }

        recent_sale = '<div class="recent-sale">';
            recent_sale += '<div class="rs-image-container">';
                recent_sale += '<span class="image-aligner"></span>';
                recent_sale += '<img src="' + recent_sales_item['image_url'] + '">';
            recent_sale += '</div>';

            recent_sale += '<div class="rs-text-container">';
                recent_sale += '<div>';
                    recent_sale += '<p>Someone in ' + recent_sales_item['location'] + ' recently bought ' + recent_sales_item['quantity'] + ' x <a href="' + recent_sales_item['product_url'] + '">' + recent_sales_item['product_name'] + '</a>.</p>';
                recent_sale += '</div>';
            recent_sale += '</div>';
        recent_sale += '</div>';

        $("body").append(recent_sale);


        // Set timeout to give the image time to load
        setTimeout(function(){
            $(".recent-sale").fadeIn(1000);
        }, 500)

        

        recentSalesFadeOut();
        
    }

    if(!localStorage.recent_sales_i)
    {
        localStorage.recent_sales_i = 0;
    }
    

    rs_first_loop = true;


    function recentSalesExecutor(call_var)
    {
        if($(".recent-sale").length)
        {
            $('.recent-sale').fadeOut(1000, function() {
                recentSalesRenderer(recent_sales_info_object[call_var]);
            });
        }
        else
        {
            recentSalesRenderer(recent_sales_info_object[call_var]);
        }
    }

    function recentSalesLooper() {
        if(!localStorage.recent_sales_info)
        {	
            fetchRecentSalesData(0);
        }
        else
        {	
            recent_sales_info_object = JSON.parse(localStorage.recent_sales_info);

            display_interval_range = 30; //Display Interval Default
            
            if(localStorage.recent_sales_display_interval_range)
            {
                display_interval_range = parseInt(localStorage.recent_sales_display_interval_range);
            }

            if(localStorage.recent_sales_i >= recent_sales_info_object.length)
            {	
                return
            }

            if(rs_first_loop)
            {
                rs_first_loop = false;

                call_var = localStorage.recent_sales_i;

                recentSalesExecutor(call_var);

                localStorage.recent_sales_i++;

                if (localStorage.recent_sales_i < recent_sales_info_object.length)
                {
                    recentSalesLooper();
                }
            }
            else
            {	
                random_number = Math.floor((Math.random() * (display_interval_range-15)) + 15);

                random_number = random_number * 1000;

                setTimeout(function ()
                {	

                    call_var = localStorage.recent_sales_i;

                    recentSalesExecutor(call_var);

                    localStorage.recent_sales_i++;

                    if (localStorage.recent_sales_i < recent_sales_info_object.length)
                    {
                        recentSalesLooper();
                    }


                }, random_number)
            }

        }

    }

    function fetchRecentSalesData(delay_time)
    {	
        localStorage.recent_sales_i = 0;

        window.recent_sales_fetch_count++;

        if(!delay_time)
        {
            delay_time = 0;
        }

        if(window.recent_sales_fetch_count <= 2)
        {

            window.wwwApi.recentSales.getRecentSales().then(response => {

                if(response['recent_sales'])
                {
                    localStorage.recent_sales_info = JSON.stringify(response['recent_sales']);
                }

                if(response['refresh_time'])
                {
                    localStorage.recent_sales_refresh_time = response['refresh_time'];
                }

                if(response['display_interval'])
                {
                    localStorage.recent_sales_display_interval_range = response['display_interval'];
                }
                
                
            });

            // start after delay time
            setTimeout(function ()
            {
                recentSalesLooper();
            }, delay_time);

        }
    }

    function recentSalesInitiator()
    {
        if(window.show_recent_sales && detectLocalStorage())
        {
            // Firstly check to see if we have recent sales info
            if(!localStorage.recent_sales_info)
            {	
                // We don't thus lets get some via AJAX
                fetchRecentSalesData(5000);

                time_now = new Date().getTime();

                localStorage.recent_sales_last_fetch = time_now;
            }
            else
            {	
                // We do so lets make sure it's up to date, in our case within 3 days
                expire_range = 1; // Minutes

                
                // var time_range = new Date(today - expire_range * MS_PER_MINUTE);

                // Logic for this is the following:
                // Get now in miliseconds, get last fetch time in miliseconds.
                // If now - fetch_time is greater than max_time_before_refresh in miliseconds, then refresh
                var time_now = new Date();
                var MS_PER_MINUTE = 60000;
                var max_time_before_refresh_minutes = 60; // Default

                if(localStorage.recent_sales_refresh_time)
                {
                    var max_time_before_refresh_minutes = parseInt(localStorage.recent_sales_refresh_time);
                }
        
                var max_time_before_refresh_milliseconds = max_time_before_refresh_minutes*MS_PER_MINUTE;

                if(!localStorage.recent_sales_last_fetch || (time_now.getTime() - localStorage.recent_sales_last_fetch) > max_time_before_refresh_milliseconds)
                {	
                    // Data needs to be refetched
                    // So clear current sales data
                    localStorage.removeItem("recent_sales_info");

                    // Fetch new sales data
                    fetchRecentSalesData(5000);

                    time_now = new Date().getTime();

                    localStorage.recent_sales_last_fetch = time_now;
                }
                else
                {	
                    display_interval_range = 30; //Display Interval Default
            
                    if(localStorage.recent_sales_display_interval_range)
                    {
                        display_interval_range = parseInt(localStorage.recent_sales_display_interval_range);
                    }

                    random_number = Math.floor((Math.random() * (display_interval_range-5)) + 5);
                    random_number = random_number * 1000;

                    setTimeout(function(){recentSalesLooper();}, random_number)

                }
                
            }
        }
        
    }

    recentSalesInitiator()

    



    // This is a function for basically activing the users choice on ICDS
    $('body').on('change', '.ICDS-user-choice-form input', function ()
    {	

        // Firstly lets get the switch value so we don't have to get that later
        switch_value = $(this).val();

        // Now lets get our parent offer container
        ICDS_container = $(this).closest(".ICDS-offer");

        // Lets get our offer id from the ICDS container
        offer_id = $(this).closest(".ICDS-offer").attr("id").replace('offer-','');

        // Now lets get our variant container
        variants_container = ICDS_container.find(".offer-variants-container");

        // Define a variable to tell us if we should execute our AJAX to update choice
        execute_choice_ajax = false;

        // Confirm we have a variants container
        if(variants_container)
        {	
            // Now lets get a list of each of the variants
            offer_variants = variants_container.find(".offer-variant");

            // So lets iterate through the variants
            offer_variants.each(function() {

                country_variant_id = $(this).attr('id');
                
                // Confirm offer is in window.ICDS_offer_variable_info
                if(offer_id in window.ICDS_offer_variable_info)
                {

                    // Confirm that the variant is in window.ICDS_offer_variable_info too
                    if(country_variant_id in window.ICDS_offer_variable_info[offer_id])
                    {
                        // Here we can anaylse what we are switching

                        // Lets see if our switch value is value
                        if(switch_value == 'value')
                        {	
                            // If so lets confirm that the value option is in window.ICDS_offer_variable_info
                            if('value' in window.ICDS_offer_variable_info[offer_id][country_variant_id])
                            {	

                                // Now lets append this value to the variant object
                                append_discount = ' $'+window.ICDS_offer_variable_info[offer_id][country_variant_id]['line_total_value'];
    
                                // If the variant qty is > 1 lets append the value per item too
                                if(window.ICDS_offer_variable_info[offer_id][country_variant_id]['qty'] > 1)
                                {
                                    append_discount += ' <small class="discount-per-item">($'+window.ICDS_offer_variable_info[offer_id][country_variant_id]['value']+' per item)</small>';
                                }
                                
                                // Finally lets empty the green element and append this append_discount variable
                                $(this).find(".green-discount").first().html(append_discount);

                                //Define the execute choice ajax as value
                                execute_choice_ajax = 'value'

                            }
                        }

                        // Lets see if our switch value is terms
                        else if(switch_value == 'terms')
                        {

                            // If so lets confirm that the terms option is in window.ICDS_offer_variable_info
                            if('terms' in window.ICDS_offer_variable_info[offer_id][country_variant_id])
                            {	
                                // Now lets append this terms value to the variant object
                                append_discount = ' ' + window.ICDS_offer_variable_info[offer_id][country_variant_id]['terms'] + ' days extended terms';
        
                                // Finally lets empty the green element and append this append_discount variable
                                $(this).find(".green-discount").first().html(append_discount);

                                //Define the execute choice ajax as value
                                execute_choice_ajax = 'terms'
                            }
                        }

                        // Finally lets see if our switch value is split
                        else if(switch_value == 'split')
                        {
                            // If so lets confirm that the terms option is in window.ICDS_offer_variable_info
                            if('split_discount' in window.ICDS_offer_variable_info[offer_id][country_variant_id] && 'split_terms' in window.ICDS_offer_variable_info[offer_id][country_variant_id])
                            {	

                                // Now lets append this value to the variant object
                                append_discount = ' $'+window.ICDS_offer_variable_info[offer_id][country_variant_id]['line_total_split_value'];

                                // If the variant qty is > 1 lets append the value per item too
                                if(window.ICDS_offer_variable_info[offer_id][country_variant_id]['qty'] > 1)
                                {
                                    append_discount += ' <small class="discount-per-item">($'+window.ICDS_offer_variable_info[offer_id][country_variant_id]['split_discount']+' per item)</small>';
                                }

                                // Now add our terms value
                                append_discount += ' & ' + window.ICDS_offer_variable_info[offer_id][country_variant_id]['split_terms'] + ' days extended terms';

                                $(this).find(".green-discount").first().html(append_discount);

                                //Define the execute choice ajax as value
                                execute_choice_ajax = 'split'
                            }
                        }

                        // Check if the execute_choice_ajax is not false, and if so execute the ajax call
                        if(!execute_choice_ajax == false)
                        {
                            //Ajax get variants and put into variants
                            window.wwwApi.cart.selectDiscount(Number(offer_id), execute_choice_ajax)
                        }

                    }

                }

            });
        }

        // Lets also append the total

        // Firstly lets check if its value we want from the switch value
        if(switch_value == 'value')
        {	
            //Confirm we have 'offer_total_value' in our window.ICDS_total_info
            if('offer_total_value' in window.ICDS_total_info[offer_id])
            {	
                // If so lets get the total strong div
                total_append_div = $("#offer-"+offer_id+" .offer-value strong");

                // Lets append the value
                total_append_div.html('$'+window.ICDS_total_info[offer_id]['offer_total_value']);
            }

            window.ICDS_cart_info['discounts_applied'][offer_id] = window.ICDS_total_info[offer_id]['offer_total_value']; 
        }

        // Else lets check if the value is terms
        if(switch_value == 'terms')
        {	
            //Confirm we have 'offer_total_terms' in our window.ICDS_total_info
            if('offer_total_terms' in window.ICDS_total_info[offer_id])
            {	
                // If so lets get the total strong div
                total_append_div = $("#offer-"+offer_id+" .offer-value strong");

                // Lets append the value
                total_append_div.html(window.ICDS_total_info[offer_id]['offer_total_terms']+' days extended terms');
            }

            window.ICDS_cart_info['discounts_applied'][offer_id] = 0;
        }

        // Finally we can see if we have the else of split
        if(switch_value == 'split')
        {
            //Confirm we have 'offer_total_terms' in our window.ICDS_total_info
            if('offer_split_value' in window.ICDS_total_info[offer_id] && 'offer_split_terms' in window.ICDS_total_info[offer_id])
            {
                // If so lets get the total strong div
                total_append_div = $("#offer-"+offer_id+" .offer-value strong");

                // Lets append the value
                total_append_div.html('$'+window.ICDS_total_info[offer_id]['offer_split_value'] + ' and ' + window.ICDS_total_info[offer_id]['offer_split_terms']+' days extended terms');
            }

            window.ICDS_cart_info['discounts_applied'][offer_id] = window.ICDS_total_info[offer_id]['offer_split_value'];
        }

        

        // CALL FUNCTION
        update_cart_totals();

    });


    // Function to check if offers are currently being calculated and thus no display the offer_detail page and then referesh to check

    $('body').on('click', '.ovtb', function ()
    {	
        if($(this).hasClass('offer-variants-closed-heading'))
        {
            button = $(this).prev();
        }
        else if($(this).hasClass('offer-variants-open-heading'))
        {
            button = $(this).prev().prev();
        }
        else
        {
            button = $(this)
        }
        

        if(button.hasClass('closed'))
        {
            button.toggleClass('closed');
            button.next().hide();
            button.next().next().show();
            button.next().next().next().slideDown();
        }
        else
        {
            button.toggleClass('closed');
            button.next().show();
            button.next().next().hide();
            button.next().next().next().slideUp();
        }
    });



    // Function for toggling hidden gateways
    $(".toggle-hidden-gateways").click(function(){
        $(this).next().slideToggle();
        $(this).find('i').toggleClass('chevron-flip');
    })

    //ON CHECKOUT CLICK SHOW FREIGHT DISCOUNT

    window.show_freight_popup = false;
    window.freight_popup_value = 0;
    window.freight_popup_required_value = 0;


    $("#cart-checkout-begin-form").click(function(e){
        window.show_freight_popup = false;  // logic for this isn't working, kill pending full cart rebuild
        if(window.show_freight_popup)
        {
            e.preventDefault();
            $(".freight-discount-popup strong").html('$'+window.freight_popup_value);
            $(".freight-discount-popup").fadeIn();
            $('.lightbox-cover').fadeIn();
            // window.show_freight_popup = false;
        }
    });

    $(".freight-discount-popup .btn-secondary-outline").click(function(){
        $("#cart-checkout-begin-form").submit();
    });

    $(".freight-discount-popup .btn-primary").click(function(){
        $('.lightbox-cover').fadeOut();
        $('.lightbox').fadeOut();
    });


    //ALLOW REPRESENATIVE FORM TO WORK WITHOUT USING A DROP DOWN
    //This basically allows us to use buttons and to change the dropdown's value and then submits the form
    $(".representative-switch").click(function(e){
        e.preventDefault();
        rep_id = $(this).attr('data-rep-id');
        form = $("#representatives form");
        form.find("select").first().val(rep_id);
        form.submit();
    });

    //ANIMATE OFFERS ON HOME PAGE (functions at bottom of page)
    if($(".offer-top-container .offer").length > 1)
    {
        $(".offer-top-container .offer").hide();
        animateHomeOffersController('top');
    }
    else
    {
        $(".offer-top-container .offer").show();
    }

    if($(".offer-bottom-container .offer").length > 1)
    {
        $(".offer-bottom-container .offer").hide();
        animateHomeOffersController('bottom');
    }
    else
    {
        $(".offer-bottom-container .offer").show();
    }


    //SITEWIDE CUSTOM SELECT AND CHECK SCRIPTS (CHECK NOT BUILT)

    //Click on custom select function
    $('body').on('click', '.custom-select', function () {
        
        if(!$(this).hasClass("active"))
        {
            //Clear other ticks
            $(this).parent().find(".custom-select").empty();
            $(this).parent().find(".custom-select.active").removeClass("active");
            $(this).parent().find(".custom-field-label.active").removeClass("active");

            //Make active
            $(this).addClass('active').append('<i class="fa fa-check"></i>');
            $(this).next().addClass("active");

            //Get related form
            related_form = $(this).parent().attr('data-change');

            //Get value
            change_value = $(this).attr('data-val');

            if($("#"+related_form).length)
            {
                $("#"+related_form).val(change_value);
            }

            window.display_backorder = false;

            if(change_value in window.backorder_list)
            {
                if(window.backorder_list[change_value] != 'no-eta')
                {
                    window.backorder_eta = window.backorder_list[change_value]
                }
                else
                {
                    window.backorder_eta = '';
                }

                window.display_backorder = true;
            }
        }
    });

    $('body').on('click', '.custom-field-label', function () {
        if(!$(this).hasClass("active"))
        {
            //Clear other ticks
            $(this).parent().find(".custom-select").empty();
            $(this).parent().find(".custom-select.active").removeClass("active");
            $(this).parent().find(".custom-field-label.active").removeClass("active");

            //Make active
            $(this).prev().addClass('active').append('<i class="fa fa-check"></i>');
            $(this).addClass("active");

            //Get related form
            related_form = $(this).parent().attr('data-change');

            //Get value
            change_value = $(this).prev().attr('data-val');

            if($("#"+related_form).length)
            {
                $("#"+related_form).val(change_value);
            }

            window.display_backorder = false;

            if(change_value in window.backorder_list)
            {
                if(window.backorder_list[change_value] != 'no-eta')
                {
                    window.backorder_eta = window.backorder_list[change_value]
                }
                else
                {
                    window.backorder_eta = '';
                }

                window.display_backorder = true;
            }
        }
    });

    //CAT ADD TO CART SCRIPTS
    $(".cat-add-to-cart").click(function(){

        $("#fill-prod-name").text($(this).parent().find('h4').text());
        img_url = $(this).parent().find(".image-container").first().css('background-image');
        if(!img_url)
        {
            // Catch for List view
            img_url = $(this).parent().next().next().find('div').first().css('background-image');
        }

        if(img_url)
        {
            img_url = img_url.replace('url(','').replace(')','').replace(/"/gi, "");
            $("#added-to-cart-item img").attr('src', img_url);
        }
        

        //Ajax get variants and put into variants
        formData = 'action=get_variants&product_id=' + $(this).attr('data-attr-id');
        $.ajax({
        type: 'GET',
        url: window.appConfig.urls.cartLegacy,
        data: formData,
        beforeSend: function(){
            $("#fill-prod-variant").empty();
            $("#fill-prod-variant-selector").empty();
            
        }
        }).done(function(response) {

            if(response.type == 'variants' && response.variants.length)
            {

                window.backorder_list = {}

                for (var i = response.variants.length - 1; i >= 0; i--) {
                    
                    if(i == 0)
                    {
                        appendVariant = '<div class="custom-select active" data-val="'+response.variants[i][1]+'"><i class="fa fa-check"></i></div><span class="custom-field-label active">'+response.variants[i][0]+'</span>';
                        
                        //Excute the form to fill this variant
                        related_form = $("#fill-prod-variant").attr('data-change');

                        //Get value
                        change_value = response.variants[i][1];

                        if($("#"+related_form).length)
                        {
                            $("#"+related_form).val(change_value);
                        }


                        if(response.variants[i].length == 4)
                        {	
                            // There is no stock of this variant, display backorder warning

                            if(response.variants[i][3])
                            {	
                                mon = response.variants[i][3].replace(/[0-9]/g, '').replace(/\s/g, '');
                                day = response.variants[i][3].replace(/\D/g,'').replace(/\s/g, '');
                                eta = new Date(Date.parse(mon +" "+day+", 2012"));

                                window.backorder_list[change_value] = eta
                            }
                            else
                            {
                                window.backorder_list[change_value] = 'no-eta'
                            }
                        }

                        window.display_backorder = false;
                        if(change_value in window.backorder_list)
                        {

                            if(window.backorder_list[change_value] != 'no-eta')
                            {
                                window.backorder_eta = window.backorder_list[change_value]
                            }
                            else
                            {
                                window.backorder_eta = '';
                            }

                            window.display_backorder = true;
                        }


                    }
                    else
                    {
                        appendVariant = '<div class="custom-select" data-val="'+response.variants[i][1]+'"></div><span class="custom-field-label">'+response.variants[i][0]+'</span>';
                    }

                    $("#fill-prod-variant").append(appendVariant); 

                }
                


                
            }
            else if(response.type == 'selectors' && Object.keys(response.selectors).length > 0 && Object.keys(response.variant_matrix).length > 0)
            {

                appendSelectors = '<span class="selector-title">Choose variations:</span><ul>';

                for (var selector_info_key in response.selectors) {
                    if (response.selectors.hasOwnProperty(selector_info_key)) {
                       

                        appendSelector = '<div class="variant-selector" data-selector-var="'+selector_info_key+'">';
                        appendSelector += '<span class="selector-name">'+response.selectors[selector_info_key]['label']+':</span>';

                        for (var selector_choice in response.selectors[selector_info_key]['values']) {
                            if (response.selectors[selector_info_key]['values'].hasOwnProperty(selector_choice)) {

                                appendSelector += '<li>';
                                appendSelector += '<button class="variant-selector-button" data-selector="'+response.selectors[selector_info_key]['values'][selector_choice]+'">'+selector_choice+'</button>';
                                appendSelector += '</li>';

                            }
                        }
                        

                        appendSelector += '</div>';

                        appendSelectors += appendSelector;

                    }
                }

                appendSelectors += '</ul>';
                $("#fill-prod-variant-selector").append(appendSelectors)

                selector_matrix = response.variant_matrix;

                default_var = variant_selector_initiate()['startingVar'];

                $("#id_country_variant").val(default_var);

            }

        });


        $('.lightbox-cover').fadeIn();
        $('.lightbox.ajax-cat-cart-add').fadeIn();
    });


    // Variant Selector Initiate
    function variant_selector_initiate()
    {

        // We need to find out what position we can execute
        selector_levels = {}
        $(".variant-selector").each(function(){
            selector_levels[$(this).attr("data-selector-var")] = true;
        });

        level_values = {1:0}

        if('2' in selector_levels)
        {
            level_two_value = 0;
            found_level_two_value = false;

            while (found_level_two_value == false) {
                if(selector_matrix[0][level_two_value])
                {
                    found_level_two_value = true;
                    break
                }
                else
                {
                    level_two_value += 1;
                }
            }

            level_values[2] = level_two_value;

        }

        if('3' in selector_levels)
        {
            level_three_value = 0;
            found_level_three_value = false;

            while (found_level_three_value == false) {
                if(selector_matrix[0][level_two_value][level_three_value])
                {
                    found_level_three_value = true;
                    break
                }
                else
                {
                    level_three_value += 1;
                }
            }

            level_values[3] = level_two_value;
        }


        selector_levels = {}
        $(".variant-selector").each(function(){

            level_value = level_values[parseInt($(this).attr("data-selector-var"))];

            if($(this).find(".variant-selector-button").length)
            {
                $(this).find(".variant-selector-button[data-selector='"+level_value+"']").addClass('active');
            }
            else if($(this).find(".variant-select-selector").length)
            {
                $(this).find(".variant-selector-selector").val(level_value);
            }

            selector_levels[$(this).attr("data-selector-var")] = true;
            
        });

        if(3 in level_values)
        {
            var startingVar = selector_matrix[level_values[1]][level_values[2]][level_values[3]]['country_variant_id'];
            var rootVar = selector_matrix[level_values[1]][level_values[2]][level_values[3]]['root_variant_id'];
            var variant_name_text = selector_matrix[level_values[1]][level_values[2]][level_values[3]]['variant_name'];
        }
        else if(2 in level_values)
        {
            var startingVar = selector_matrix[level_values[1]][level_values[2]]['country_variant_id'];
            var rootVar = selector_matrix[level_values[1]][level_values[2]]['root_variant_id'];
            var variant_name_text = selector_matrix[level_values[1]][level_values[2]]['variant_name'];
        }
        else if(1 in level_values)
        {
            var startingVar = selector_matrix[level_values[1]]['country_variant_id'];
            var rootVar = selector_matrix[level_values[1]]['root_variant_id'];
            var variant_name_text = selector_matrix[level_values[1]]['variant_name'];
        }

        // Disable Options
        

        if (2 in level_values)
        {
            
            // Two levels, so depending on 2 some 3 options may be disablable

            if($(".variant-selector[data-selector-var='2'] .variant-selector-button").length)
            {
                $(".variant-selector[data-selector-var='2'] .variant-selector-button").each(function(){

                    if(!(parseInt($(this).attr("data-selector")) in selector_matrix[level_values[1]]))
                    {
                        $(this).prop('disabled', true)
                    }

                });
            }
            else if($(".variant-selector[data-selector-var='2'] .variant-selector-selector").length)
            {
                $(".variant-selector[data-selector-var='2'] .variant-selector-selector option").each(function(){

                    if(!(parseInt($(this).val()) in selector_matrix[level_values[1]]))
                    {
                        $(this).prop('disabled', true)
                    }

                });
            } 		

        }

        if(3 in level_values)
        {	
            
            // Three levels, so depending on 2 some 3 options may be disablable
            if($(".variant-selector[data-selector-var='3'] .variant-selector-button").length)
            {

                $(".variant-selector[data-selector-var='3'] .variant-selector-button").each(function(){

                    if(!(parseInt($(this).attr("data-selector")) in selector_matrix[level_values[1]][level_values[2]]))
                    {
                        $(this).prop('disabled', true)
                    }

                });
            }
            else if($(".variant-selector[data-selector-var='3'] .variant-selector-selector").length)
            {
                $(".variant-selector[data-selector-var='3'] .variant-selector-selector option").each(function(){

                    if(!(parseInt($(this).val()) in selector_matrix[level_values[1]][level_values[2]]))
                    {
                        $(this).prop('disabled', true)
                    }

                });
            } 		

        }


        return {'startingVar':startingVar,'rootVar':rootVar,'variant_name_text':variant_name_text}
    }


    //TOUR SCRIPTS (old tour scripts)
    /*

    //Show tutorial tool-tip on hover
    $(".tutorial-icon").hover(function(){
        if(!$(this).hasClass("active"))
        {
            $(".tutorial-hover").fadeIn();
        }
    },
    function(){
        $(".tutorial-hover").fadeOut();
    });

    //Check if the interdyn tour cookie is set and if so continue the tour on the relevent page
    if($.cookie("interdyn_tour") == "1")
    {
        check_next_tour();
    }

    //Open on icon click


    $(".tutorial-icon").click(function()
    {
        $.cookie("interdyn_tour", 1, { path: '/' });

        if(!$(this).hasClass("active"))
        {
            $('#InterdynJoyrideTour-home').joyride({
                autoStart: true,
                postRideCallback: function () {
                    joyride_end();
                    check_next_tour();
                },
                modal: false,
                expose: true
            });
            $(".tutorial-icon").addClass("active");
            $(".tutorial-pointer-container").fadeOut();
            $(".tutorial-hover").fadeOut();
        }
    });

    //Close lightbox of suggested tutorial
    $(".tutorial-pointer-container").click(function(){
        $(this).fadeOut();
    });

    //Close tour on close button click
    $('body').on('click', '.joyride-end', function () {

        joyride_kill();
        joyride_end();

    });
    */

    //Print Form JS to Make Work

    //Populate Store Addresses
    address_i = 0;
    $("#id_address option").each(function()
    {


        if(address_i == 0)
        {
            appendAddress = '<div class="print-select"></div><span data-val="">Hide Store Address</span>';
        }
        else if($(this).prop('selected'))
        {
            appendAddress = '<div class="print-select"><i class="fa fa-check"></i></div><span data-val="'+$(this).val()+'">'+$(this).text()+'</span>';
        }
        else
        {
            appendAddress = '<div class="print-select"></div><span data-val="'+$(this).val()+'">'+$(this).text()+'</span>';
        }

        $(".print-store-addresses").append(appendAddress);
        address_i++;
    });

    //Populate Store Variants
    $("#id_variants li").each(function()
    {
        appendVariant = '<div class="print-check"><i class="fa fa-check"></i></div><span data-for="'+$(this).find("input").attr("id")+'">'+$(this).text()+'</span>';
        $(".print-variants").append(appendVariant);

    });

    //Make print-select options work
    $('body').on('click', '.print-select', function () {
        $(this).parent().find('.print-select').empty();
        $(this).append('<i class="fa fa-check"></i>');

        //Update Form
        inputID = $(this).parent().attr('data-for');
        if(inputID == 'id_address')
        {
            $("#"+inputID).val($(this).next().attr("data-val"));
        }
        else if(inputID == 'id_sales_person')
        {
            if($(this).next().attr("data-val") == 0)
            {
                $("#"+inputID).prop('checked',false);
            }
            else
            {
                $("#"+inputID).prop('checked',true);
            }
        }

    });

    //Make print-select options work
    $('body').on('click', '.print-check', function () {
        inputID = $(this).next().attr('data-for');
        if($(this).children().length > 0)
        {
            $(this).empty();
            $("#"+inputID).prop('checked',false);
        }
        else
        {	
            $(this).append('<i class="fa fa-check"></i>');
            $("#"+inputID).prop('checked',true);
        }
    });



    Handlebars.registerHelper('ifEqual', function(v1, v2, options) {
      if(v1 === v2) {
        return options.fn(this);
      }
      return options.inverse(this);
    });
    //productBlockInstall();

    //MENU 1
    //Set the submenu left offest to match it up with menu
    $( ".sub-menu").each(function( index ) {
        var dropDownMenuWidth = $(this).parent().parent().parent().width();
        $(this).css("left",dropDownMenuWidth);
    });

    //Set the Nav to Open
    $('.dropdown-button').on('click', function (event) {
        $(this).parent().toggleClass("open");
    });

    //Close the Brand Nav if outside it is clicked
    $(document).on('click', function(event) {
    if (!$(event.target).closest('.dropdown').length) {
        $('.dropdown').removeClass('open');
        $( ".sub-menu").hide();
        $(".dropdown-menu").removeClass("ddm-shadow");
    }

    });

    //S Class Account Buttons
     $(".s-account-actions button").click(function(){
         accountTraget = '#' + $(this).attr('data-target');
         if($(accountTraget).length)
         {	
             if(!$(this).hasClass('active'))
             {	
                 $(".s-account-actions button").removeClass('active');
                 $(".s-account-content.open").slideUp(400,function() {$(accountTraget).slideDown().addClass('open')}).removeClass('open');
                 $(this).addClass('active');
             }
             
         }
     });

     //S Class Get from # or make sure first is active
    if(window.location.hash)
    {	
        accountTraget = window.location.hash;
        if($(accountTraget).length)
         {	
            $(accountTraget).show().addClass('open');
            $('.s-account-actions button[data-target="'+window.location.hash.replace('#','')+'"]').addClass('active');
        }
        else
        {
            $(".s-account-content:first").show().addClass('open');
            $(".s-account-actions button:first").addClass('active');
        }
    }
    else
    {
         $(".s-account-content:first").show().addClass('open');
        $(".s-account-actions button:first").addClass('active');
    }

    //S Class new-account-nav fix
     $(".new-account-nav li a").click(function(){
         if($(this).attr('href').indexOf('#') > -1)
         {
             accountTraget = '#' + $(this).attr('href').split('#')[1];
             if($(accountTraget).length)
             {	
                 if(!$('.s-account-actions button[data-target="'+accountTraget.replace('#','')+'"]').hasClass('active'))
                 {	
                     $(".s-account-actions button").removeClass('active');
                     $(".s-account-content.open").slideUp(400,function() {$(accountTraget).slideDown().addClass('open')}).removeClass('open');
                     $('.s-account-actions button[data-target="'+accountTraget.replace('#','')+'"]').addClass('active');
                 }
             }
         }
     });


    var NavLOneAllowLink = 0;
    var NavLTwoAllowLink = 0;
    var menuOpening = 0;
    //OPEN SUB NAV
    $("a.sub-button").hover(function(){

        //Close Products Nav
        $("#products-nav").slideUp().removeClass("open");
        $('.sub-sub-button.active').removeClass("active");

        subNav = $(this).attr("data-nav");
        menuOpening = 1;
        $("#"+subNav+"-nav").slideDown();
        $(this).addClass("active");
        setTimeout(function(){ NavLOneAllowLink = subNav; menuOpening = 0; }, 500);
    }).click(function(event){
        if(NavLOneAllowLink != $(this).attr("data-nav"))
        {
            event.preventDefault();
        }
    });

    //OPEN SUB SUB NAV
    var menuClosing = 0;
    var mobile_prevent = 0;
    $("a.sub-sub-button").mouseenter(function(){

        if($(window).width() < 400)
        {
            mobile_prevent = 1;
            setTimeout(function(){ mobile_prevent = 0;}, 500);
        }

        subSubNavMarginLeft = $(this).offset().left;
        
        //Check to make sure sub nav isnt already open if not close all
        subsubNav = $(this).attr("data-nav");

        if(subsubNav == 'products')
        {
            if(!$("#"+subsubNav+"-nav").hasClass("open") && menuClosing === 0)
            {
            menuClosing = 1;
            $( ".sub-sub-nav-container").slideUp();
            $(".sub-sub-nav-container.open").removeClass("open");
            $('.sub-nav').slideUp();
            $('.sub-sub-button.active').removeClass("active");

            setTimeout(function() {$('.sub-button.active').removeClass("active"); menuClosing = 0;}, 700);

            $("#"+subsubNav+"-nav").slideDown();
            $("#"+subsubNav+"-nav").addClass("open").css("margin-left",subSubNavMarginLeft);
            
            //only allow if not mobile
            if($(window).width() > 400)
            {
                setTimeout(function(){ NavLTwoAllowLink = subsubNav;}, 500);
            }
                        

            $("#"+subsubNav+"-nav").css('top','65px');
            }

            $(this).addClass("active");
            
        }
        else
        {
            if(!$("#"+subsubNav+"-nav").hasClass("open") && menuClosing === 0)
            {	
                $(this).addClass("active");
                $(".sub-sub-nav-container").hide();
                $('.sub-sub-button.active').removeClass("active");
                $(".sub-sub-nav-container.open").removeClass("open");
                $(this).addClass("active");
                $("#"+subsubNav+"-nav").slideDown();
                $("#"+subsubNav+"-nav").addClass("open").css("margin-left",subSubNavMarginLeft);
                setTimeout(function(){ NavLTwoAllowLink = subsubNav;}, 500);
            }
        }
        

    }).click(function(event){
        if(NavLTwoAllowLink != $(this).attr("data-nav"))
        {
            event.preventDefault();
        }
    });

    //Check non menu or sub menu close
    $(document).on('click', function(event) {

    if ($(event.target).closest('.sub-nav').length)
    {
        return;
    }
    else if($(event.target).closest('.sub-sub-nav').length)
    {
        return;
    }
    else if(menuOpening !== 0)
    {
        return;
    }
    else if(mobile_prevent !== 0)
    {
        return;
    }
    else
    {

            menuClosing = 1;
            $( ".sub-sub-nav-container").slideUp();
            $(".sub-sub-nav-container.open").removeClass("open");
            setTimeout(function() {
            $('.sub-nav').slideUp();
            $('.sub-sub-button.active').removeClass("active");
            }, 300);
            setTimeout(function() {$('.sub-button.active').removeClass("active"); menuClosing = 0;}, 700);
    }

    });
    

    function toggleDealerPrice()
    {
        var visCost = $("#product-price button").prev().prev().find(".cost").first().find(".cost");
        var visLabel = $("#product-price button").prev().prev().find(".rrp");
        var hiddenCost = $("#product-price button").prev().find("div.rrp").first().find("span.cost");
        var rrp = visCost.text();
        var dealerPrice = hiddenCost.text();
        const discountElement = document.querySelector("#product-dealer-price .discount");
        if (!discountElement) {
            const discountValueElement = null;
        } else {
            const discountValueElement = discountElement.querySelector(".discount .cost");
        }

        if(!$("#product-price").hasClass("open"))
        {
            //OPEN
            $("#product-price button").text("Hide");
            $("#product-price button").prev().show();
            visCost.text(dealerPrice);
            hiddenCost.text(rrp);
            visLabel.text("DEALER PRICE");
            // $(".new-price .btn").css("margin-bottom","10px");
            // $(".add-to-cart").css("margin-top","5px");
            $("#product-price").addClass("open");
            $(".new-price span.gst").text("(excl. GST)");
            VerticallyAlignProductInfo();

            $(".go-price").show();
        }
        else
        {
            //CLOSE
            $("#product-price button").text("Click to Show Dealer Price");
             $("#product-price button").prev().hide();
            visCost.text(dealerPrice);
            hiddenCost.text(rrp);
            visLabel.text("RRP");
            // $(".new-price .btn").css("margin-bottom","25px");
            // $(".add-to-cart").css("margin-top","28px");
            $("#product-price").removeClass("open");
            $(".new-price span.gst").text("(inc. GST)");
            VerticallyAlignProductInfo();

            $(".go-price").hide();
        }
    }

    //Product Page --> Switch RPP to Dealer Price
    $("#product-price button").click(function() {
  
        toggleDealerPrice();
     
    });
    

    //---GALLERY PLUGIN--

    function galleryStart()
    {	

        //Remove no-loaded color images
        //Get orignal active
        
        // If selector exeucte 0,0,0 position, else just get variant
        if($(".variant-selector").length)
        {
            
            selector_vars = variant_selector_initiate();
            var startingVar = selector_vars.startingVar;
            var rootVar = selector_vars.rootVar;
            var variant_name_text = selector_vars.variant_name_text;

            if(startingVar in eol_variants)
            {
                $(".variant-selectors-eol").show();
                // new_outer_height = ($(".new-product-info-box-wrapper").height() + 38);
                // $(".new-product-info-box-wrapper").height(new_outer_height);
            }

        }
        else
        {
            /*
            var startingVar = $(".new-product-variants button.active").attr("data-var");
            var rootVar = $(".new-product-variants button.active").attr("data-p-var");
            var variant_name_text = $(".new-product-variants li button.active").text();
            */
            // NPV Update
            var startingVar = $("._2018-product-variants .variant-container.active").attr("data-var");
            var rootVar = $("._2018-product-variants .variant-container.active").attr("data-p-var");
            var variant_name_text = $("._2018-product-variants .variant-container.active a").text();
        }

        $(".qty-variant").text(variant_name_text);
        

        // $("#variable-"+startingVar).prop("checked", true);

        $(".thumb").removeClass("active");

        $(".thumb").each(function( index ) {
            $(this).hide();
            if($(this).attr("data-var") == 'null')
            {
                $(this).show();
            }
            else if($(this).attr("data-var") == rootVar)
            {	
                $(this).show();
            }
            
        });

        $('.product-image .image').hide();

        //Load Prices
        if(variant_prices[startingVar]['rrp'] == 0)
        {
            $(".cost").hide();
            $(".no-auth, #product-price button").hide();
            $(".availability").hide();
            $(".not-available").show();
            $(".new-product-info-box .add-to-cart").hide();
            $(".lightbox.qty").removeClass("qty").addClass('false-qty');
            $(".lightbox-cover").removeClass("lightbox-cover").addClass('false-lightbox-cover');
        }
        else
        {
            $(".cost").show();
            $(".no-auth, #product-price button").show();
            $(".availability").show();
            $(".not-available").hide();
            $(".new-product-info-box .add-to-cart").show();
            $(".lightbox.false-qty").removeClass("false-qty").addClass('qty');
            $(".false-lightbox-cover").removeClass("false-lightbox-cover").addClass('lightbox-cover');
        }

        $("#product-price span.cost").text("$"+localeString(variant_prices[startingVar]['rrp']));
        $("#product-dealer-price .rrp span.cost").text("$"+localeString(variant_prices[startingVar]['dp']));
        $("#product-dealer-price .margin span.cost").text(variant_prices[startingVar]['margin']+"%");
        $("#product-dealer-price .markup span.cost").text(variant_prices[startingVar]['markup']+"%");
        if (variant_prices[startingVar]['discount']) {
            $("#product-dealer-price .discount span.cost").text(variant_prices[startingVar]['discount']+"%");
        } else {
            $("#product-dealer-price .discount").hide();
        }

        
        // Add go price if exists, else hide the element

        if(variant_prices[startingVar]['go_price']
            && variant_prices[startingVar]['go_price'] !== '0.00')
        {	
            $(".go-price .go_price_cost").text("$"+localeString(variant_prices[startingVar]['go_price']));
            $(".go-price").removeClass('force_hide');
        }
        else
        {
            $(".go-price").addClass('force_hide');
        }
        

        $('select.product-variant-select').val(startingVar);

        // $("#variant-"+startingVar).prop("checked", true);


        variant_not_for_sale = false;
        // Check if its for sale, if not disable the add to cart button
        if(not_for_sale && Object.keys(not_for_sale).length > 0)
        {	
            if(startingVar in not_for_sale)
            {
                if(not_for_sale[startingVar] == true)
                {	
                    // Variant is not for sale
                    variant_not_for_sale = true;
                }

            }

        }

        if (shouldDisplayCart) {
            if (variant_not_for_sale) {
                $("div.add-to-cart").empty();
                $("div.add-to-cart").append('<button type="button" class="btn btn-secondary btn-block" disabled>No longer available</button>');
            } else {
                $("div.add-to-cart").empty();
                $("div.add-to-cart").append('<button type="button" class="btn btn-danger btn-block add-to-cart"><i class="fa fa-cart-plus"></i> Add to Cart</button>');
            }
        }

        //Render Qty
        updateStockLevels(startingVar, variant_not_for_sale);

        


        showImageID = '#galleryitem-' + $(".thumb[data-var='"+rootVar+"']").first().attr("data-thumb");

        if($(showImageID).length)
        {
            $(showImageID).show();
            $(".thumb[data-var='"+rootVar+"']").first().addClass('active');	
        }
        else
        {
            $('.new-product-image').first().show();
            $(".thumb[data-var='null']").first().addClass('active');
        }

        // If variant is in EOL list then show the superseded-box if it exists or hide it
        if($(".superseded-box").length)
        {

            if($.inArray(parseInt(startingVar), eol_variants) > -1)
            {
                $(".superseded-box").show();
                $('.new-product-availability').hide();
                $('#product-price').hide();
                $('.add-to-cart').hide();
            }
            else
            {
                $(".superseded-box").hide();
                $('.new-product-availability').show();
                $('#product-price').show();
                $('.add-to-cart').show();
            }
        }
        
        

    }

    if(typeof(variant_prices) != "undefined")
    {
        galleryStart();
    }

    //On thumb click change image
    $(".thumb").click(function(){
        if(!$(this).hasClass("active"))
        {
            imageID = '#galleryitem-' +$(this).attr("data-thumb");
            $(".thumb.active").removeClass("active");
            $(this).addClass("active");
            $(".new-product-image").fadeOut('400');
            setTimeout(function() {$(imageID).fadeIn(400);}, 300);
        }

    });





    //Product Variable Selection Function

    function variant_selection(variant_id, variant_root_id, variant_name){

        variant_not_for_sale = false;

        // Check if its for sale, if not disable the add to cart button
        if(not_for_sale && Object.keys(not_for_sale).length > 0)
        {	
            if(variant_id in not_for_sale)
            {
                if(not_for_sale[variant_id] == true)
                {	
                    // Variant is not for sale
                    variant_not_for_sale = true;
                }

            }

        }


        if (shouldDisplayCart) {
            if (variant_not_for_sale) {
                $("div.add-to-cart").empty();
                $("div.add-to-cart").append('<button type="button" class="btn btn-secondary btn-block" disabled>No longer available</button>');
            } else {
                $("div.add-to-cart").empty();
                $("div.add-to-cart").append('<button type="button" class="btn btn-danger btn-block add-to-cart"><i class="fa fa-cart-plus"></i> Add to Cart</button>');
            }
        }


        //Render Stock Levels
        updateStockLevels(variant_id, variant_not_for_sale);


        $(".qty-variant").text(variant_name);

        if($("#product-price").hasClass("open")){toggleDealerPrice();}

        //Change Prices
        if(variant_prices[variant_id]['rrp'] == 0)
        {
            $(".cost").hide();
            $('#product-price button').hide();
            $(".no-auth, #product-price button").hide();
            $(".availability").hide();
            $(".not-available").show();
            $(".new-product-info-box .add-to-cart").hide();
            $(".lightbox.qty").removeClass("qty").addClass('false-qty');
            $(".lightbox-cover").removeClass("lightbox-cover").addClass('false-lightbox-cover');
        }
        else
        {
            $(".cost").show();
            $(".no-auth, #product-price button").show();
            $('#product-price button').show();
            $(".availability").show();
            $(".not-available").hide();
            $(".new-product-info-box .add-to-cart").show();
            $(".lightbox.false-qty").removeClass("false-qty").addClass('qty');
            $(".false-lightbox-cover").removeClass("false-lightbox-cover").addClass('lightbox-cover');
        }


        $("#product-price span.cost").text("$"+localeString(variant_prices[variant_id]['rrp']));
        $("#product-dealer-price .rrp span.cost").text("$"+localeString(variant_prices[variant_id]['dp']));
        $("#product-dealer-price .margin span.cost").text(variant_prices[variant_id]['margin']+"%");
        $("#product-dealer-price .markup span.cost").text(variant_prices[variant_id]['markup']+"%");
        $("#product-dealer-price .discount span.cost").text(variant_prices[variant_id]['discount']+"%");
        if (variant_prices[variant_id]['discount']) {
            $("#product-dealer-price .discount span.cost").text(variant_prices[variant_id]['discount']+"%");
        } else {
            $("#product-dealer-price .discount").hide();
        }


        // Add go price if exists, else hide the element

        if(variant_prices[variant_id]['go_price']
            && variant_prices[variant_id]['go_price'] !== '0.00')
        {
            $(".go-price .go_price_cost").text("$"+localeString(variant_prices[variant_id]['go_price']));
            $(".go-price").removeClass('force_hide');
        }
        else
        {
            $(".go-price").addClass('force_hide');
        }

        $('select.product-variant-select').val(variant_id);

        $(".thumb").removeClass("active");

        $(".thumb").each(function( index ) {
            if($(this).attr("data-var") !== 'null')
            {
                $(this).hide();
            }
        });

        
            
        showImageID = '#galleryitem-' + $(".thumb[data-var='"+variant_root_id+"']").first().attr("data-thumb");

        if($(showImageID).length)
        {	
            $('.new-product-image').fadeOut(400);
            $(showImageID).fadeIn(400);
            $(".thumb[data-var='"+variant_root_id+"']").show().first().addClass("active");
        }
        else
        {
            // Check if not the same image to fade in
            if(!$('.new-product-image').last().is(':visible'))
            {	
                $('.new-product-image').fadeOut(400);
                $('.new-product-image').last().fadeIn(400);
                $(".thum[data-var='null']").first().addClass('active');
            }
            
        }

        // If variant is in EOL list then show the superseded-box if it exists or hide it
        if($(".superseded-box").length)
        {
            if($.inArray(parseInt(variant_id), eol_variants) > -1)
            {
                $(".superseded-box").show();
                $('.new-product-availability').hide();
                $('#product-price').hide();
                $('.add-to-cart').hide();
            }
            else
            {
                $(".superseded-box").hide();
                $('.new-product-availability').show();
                $('#product-price').show();
                $('.add-to-cart').show();
            }
        }

    }

    // NPV Update
    /*
    $(".new-product-variants li a button").click(function(e){

        e.preventDefault();

        this_button = $(this).find("button");

        if(!$(this).hasClass("active"))
        {
            $(".new-product-variants li button").removeClass("active");
            $(this).addClass("active");

            varVal = $(this).attr("data-var");
            variant_root_val = $(this).attr("data-p-var");

            variant_selection(varVal, variant_root_val, $(this).text());
                    
        }
    });
    */

    $("._2018-product-variants a").click(function(e){

        e.preventDefault();

        // this_button = $(this).find("button");

        if(!$(this).parent().hasClass("active"))
        {
            $("._2018-product-variants .variant-container").removeClass("active");
            $(this).parent().addClass("active");

            varVal = $(this).parent().attr("data-var");
            variant_root_val = $(this).parent().attr("data-p-var");

            variant_selection(varVal, variant_root_val, $(this).text());
                    
        }
    });




    function variant_selector_update_variant(click_element, in_catalogue_view)
    {	

        if(click_element.hasClass('variant-selector-button'))
        {
            // Is a button
            click_element.parent().parent().find('.active').removeClass('active');
            click_element.addClass('active');
        }

        // Check if the next row can be active

        click_element.parent().parent().siblings().each(function () {
            if($(this).hasClass("variant-selector"))
            {
                selector_level = parseInt($(this).attr('data-selector-var'));
                if (selector_level <= parseInt(click_element.parent().parent().attr('data-selector-var'))) return;

                selector_values = []

                // Working out if we have select or buttons
                if($(this).find('.variant-selector-button').length)
                {
                    $(this).find('.variant-selector-button').each(function(){

                        selector_values.push(parseInt($(this).attr('data-selector')));
                    
                    });
                }

                else if($(this).find('.variant-select-selector').length)
                {
                    $(this).find('.variant-select-selector option').each(function(){

                        selector_values.push(parseInt($(this).val()));

                    });
                }

                //Caculate if the selector we may or may not be disabling is select or button now so we don't do it for every selector in loop
                level_selection_type_button = true;
                if($(".variant-selector[data-selector-var='"+selector_level+"'] .variant-select-selector").length)
                    level_selection_type_button = false;

                for (var i = selector_values.length - 1; i >= 0; i--) {


                    disable_option = false;

                    // check if select or button
                    if($(".variant-selector[data-selector-var='1'] .active").length)
                    {
                        active_level_one = parseInt($(".variant-selector[data-selector-var='1'] .active").attr('data-selector'));
                    }
                    else if($(".variant-selector[data-selector-var='1'] .variant-select-selector").length)
                    {
                        active_level_one = parseInt($(".variant-selector[data-selector-var='1'] .variant-select-selector").val());
                    }


                    if(selector_level == 2)
                    {
                        if (!(selector_values[i] in selector_matrix[active_level_one]))
                        {
                            disable_option = true;
                        }

                    }

                    else if(selector_level == 3)
                    {

                        // check if select or button
                        if($(".variant-selector[data-selector-var='2'] .active").length)
                        {
                            active_level_two = parseInt($(".variant-selector[data-selector-var='2'] .active").attr('data-selector'));
                        }
                        else if($(".variant-selector[data-selector-var='2'] .variant-select-selector").length)
                        {
                            active_level_two = parseInt($(".variant-selector[data-selector-var='2'] .variant-select-selector").val());
                        }

                        if (!selector_matrix[active_level_one][active_level_two] || !(selector_values[i] in selector_matrix[active_level_one][active_level_two]))
                        {
                            disable_option = true;
                        }
                    }

                    if(disable_option)
                    {
                        if(level_selection_type_button)
                        {
                            // Button
                            $(".variant-selector[data-selector-var='"+selector_level+"'] .variant-selector-button[data-selector='"+selector_values[i]+"']").prop('disabled', true).removeClass("active");
                        }
                        else
                        {
                            // Select
                            $(".variant-selector[data-selector-var='"+selector_level+"'] .variant-select-selector option[value='"+selector_values[i]+"']").prop('disabled', true).removeAttr("selected");
                        }

                    }
                    else
                    {
                        if(level_selection_type_button)
                            $(".variant-selector[data-selector-var='"+selector_level+"'] .variant-selector-button[data-selector='"+selector_values[i]+"']").prop('disabled', false);
                        else
                            $(".variant-selector[data-selector-var='"+selector_level+"'] .variant-select-selector option[value='"+selector_values[i]+"']").prop('disabled', false);
                    }
                }

                // If one of the variants isn't already active, make one of the next or prev active
                if($(".variant-selector[data-selector-var='"+selector_level+"']").find('.variant-selector-button.active').length == 0) {
                    // Make a previous or next active
                    $(".variant-selector[data-selector-var='"+selector_level+"']").find('.variant-selector-button:enabled').first().addClass("active");
                }
            }
        });



        // Check to see if all selected are active. (Subtract any selects (dropdown))

        if($(".variant-selector .active").length == ($(".variant-selector").length - $(".variant-select-selector").length))
           {

               selector_values = {}

               $(".variant-selector").each(function(){

                   if($(this).find('.active').length)
                   {
                       selector_values[parseInt($(this).attr("data-selector-var"))] = parseInt($(this).find('.active').attr('data-selector'));
                   }

                   else if($(this).find('.variant-select-selector').length)
                   {
                       selector_values[parseInt($(this).attr("data-selector-var"))] = parseInt($(this).find('.variant-select-selector').val()); 
                   }
               
               });

               

               if (1 in selector_values && 2 in selector_values && 3 in selector_values)
               {
                   variant_info = selector_matrix[selector_values[1]][selector_values[2]][selector_values[3]];
               }
               else if (1 in selector_values && 2 in selector_values)
               {
                   variant_info = selector_matrix[selector_values[1]][selector_values[2]];
               }

               else if (1 in selector_values)
               {
                   variant_info = selector_matrix[selector_values[1]];
               }

               


               if(!in_catalogue_view)
               {
                   variant_selection(variant_info['country_variant_id'], variant_info['root_variant_id'], variant_info['variant_name']);

                if($.inArray(variant_info['country_variant_id'], eol_variants) > -1)
                {	
                    if(!$(".variant-selectors-eol").is(":visible"))
                    {
                        $(".variant-selectors-eol").slideDown();
                        // new_outer_height = ($(".new-product-info-box-wrapper").height() + 38);
                        // $(".new-product-info-box-wrapper").animate({height: new_outer_height}, 400);
                    }
                }
                else
                {
                    if($(".variant-selectors-eol").is(":visible"))
                    {
                        $(".variant-selectors-eol").slideUp();
                        // new_outer_height = ($(".new-product-info-box-wrapper").height() - 38);
                        // $(".new-product-info-box-wrapper").animate({height: new_outer_height}, 400);
                    }
                    
                }
               }
               else
               {	
                   // console.log(variant_info)
                   // console.log([variant_info['country_variant_id'], variant_info['root_variant_id'], variant_info['variant_name']]);

                if($("#id_country_variant").length)
                {
                    $("#id_country_variant").val(variant_info['country_variant_id']);
                }

               }
               
          

           }
    }


    //Product Variable Selector Selection Function
    $(".new-product-variants .variant-select-selector").change(function(){
        variant_selector_update_variant($(this), false);
    });


    //Product Variable Selector Selection Function
    $(".new-product-variants .variant-selector-button").click(function(){
           variant_selector_update_variant($(this), false);

    });


    //Catalogue Quick Add Variant Selector Button Click
    $('body').on('click', "#fill-prod-variant-selector .variant-selector-button", function () {
           variant_selector_update_variant($(this), true);

    });


    //Open Qty View Products
    $('body').on('click', '.new-product-buying-info button.add-to-cart', function () {
        $(".lightbox-cover").fadeIn();
        $(".lightbox.qty").fadeIn();
    });

    //Open Recommended Products
    $("#open-lightbox-recommended").click(function(){
    });

    //Close Lightbox
    $(".lightbox .close-container, .lightbox-cover, #contine-shopping").click(function(){
        $(".lightbox-cover").fadeOut();
        $(".lightbox").fadeOut();
        if($(".wizard-section").length)
        {
            location.reload();
        }
        window.setTimeout(function(){resetAddToCartForm()},500);

        // Added remove open from back-order form
        $(".lightbox.backorder-warning").removeClass("open");

    });

    // Close Lightbox on escape press
    $(document).keyup(function(e) {
        if (e.keyCode === 27)
        {
            $(".lightbox-cover").fadeOut();
            $(".lightbox").fadeOut();
            if($(".wizard-section").length)
            {
                location.reload();
            }
            window.setTimeout(function(){resetAddToCartForm()},500);

            // Added remove open from back-order form
            $(".lightbox.backorder-warning").removeClass("open");

        }
    });

    // Close ligthbox on backorder-press
    {
        $("#backorder-close").click(function(e){

            e.preventDefault();
            $(".lightbox-cover").fadeOut();
            $(".lightbox").fadeOut();
        
            window.setTimeout(function(){resetAddToCartForm()},500);
        });
    }

    //Install Tabs
    activeLaunchTab = $(".product-detail li a.active, .tab-control li.active").attr("data-tab");
    $("#"+activeLaunchTab).show();

      //Change Tab
    $(".product-detail .nav-tabs li a, .tab-control li").click(function(event){
        event.preventDefault();
        tabID = $(this).attr("data-tab");
        $(".tab-pane").fadeOut();
        setTimeout(function(){$("#"+tabID).fadeIn();},280);
        $(".product-detail li a, .tab-control li").removeClass("active");
        $(this).addClass("active");
    });

    $('.ticker').marquee('pointer').mouseover(function () {
            $(this).trigger('stop');
        }).mouseout(function () {
            $(this).trigger('start');
        });



     //Close Country on click away
     $(".nav-country").click(function () {
         $(".country-switcher").slideToggle();
     });

     $(".account-info").click(function(event){
         event.preventDefault();
         $(".dealer-login").slideToggle();
     });


     $(document).on('click', function(event) {

        if (!$(event.target).closest('.nav-country').length && !$(event.target).closest('.country-switcher').length)
        {
            $(".country-switcher").slideUp();
        }
        if(!$(event.target).closest('.dealer-login').length && !$(event.target).closest('.account-info').length)
        {
            $(".dealer-login").slideUp();
        }
        
    });
    
    $(".qty-selector span").click(function(){

        if($(this).attr('id') == 'increase-qty')
        {	
            change_value = 1;
        }
        else if($(this).attr('id') == 'decrease-qty')
        {
            change_value = -1;
        }
        else
        {
            change_value = false;
        }

        if(change_value)
        {
            current_value = parseInt($("#product-qty").val());
            if(!isNaN(current_value))
            {
                if(current_value >= 0)
                {	
                    new_value = current_value+change_value;
                    if(new_value <= 0){new_value = 1}

                    $("#product-qty").val(new_value)
                }
                else
                {
                    $("#product-qty").val('0')
                }
            }
            else
            {
                $("#product-qty").val('0')
            }
            
            $("input#id_quantity").val($("#product-qty").val());
        }
        else
        {
            $("#product-qty").val('0')
        }
    });

    $("#product-qty").change(function(){
        if($(this).val() > 0)
        {
            $("input#id_quantity").val($(this).val());
        }
    });


    //TEMP CART QUANITIY FUNCTION
    $(".cart-qty").change(function(){
            
        remove_button = $(this).parent().next().find('button');
        update_button = $(this).next().next().next().next().next();

        if ($(update_button).css('display') === 'none') {
            $(remove_button).animate({
                marginLeft: "+=61"
            }, 400, function() {
                update_button.fadeIn();
                remove_button.css("margin-left","0px"); 
            });
        }

        fakeval = Math.ceil($(this).val());
        starval = Math.ceil($(this).next().next().val());
        updateval = fakeval - starval;
        $(this).next().val(updateval);
    });

    $(".cart-qty").each(function(){
        $(this).next().next().val($(this).val());
    });

    // $(".execute-qty-form").click(function(){
    // 	fakeval = Math.ceil($(this).prev().prev().prev().prev().prev().val());
    //     starval = Math.ceil($(this).prev().prev().prev().val());
    //     updateval = fakeval - starval;
    //     $(this).next().val(updateval);
    // });

    //TEMP CART SHOW LIGHTBOX ON ENTER KEY
     $('body').keypress(function (e) {
         var key = e.which;
         if(key == 13)  // the enter key code
          {
            $("#cart-recommened-lightbox").fadeIn();
            $("#cart-recommened-lightbox").next().fadeIn();
          }
        });



    //AJAX WITH LISTENERS
       

       $(".mini-cart-loader").hide();  // Hide it initially
       $(".success-icon").hide();  // Hide it initially
       $(".add-loading-icon").hide();  // Hide it initially

       
       // Script to make it if you press enter on the cart quantity updates item qty

    $(".update-cart").keypress(function(e) {
        if(e.which == 13) {
            e.preventDefault();
            $(this).find(".execute-qty-form").first().click()
        }
    });

    

    $(".execute-qty-form").click(function(){

        var form_qty = $('.qty-final');
     
        qty_input_identifier = $(this).prev().prev().prev().prev().prev();
        
        
        var form = qty_input_identifier.parent();
        var formObject = {};
        form.serializeArray().forEach(item => formObject[item.name] = item.value);
        
        qty_input_identifier.next().next().val(qty_input_identifier.val());

        qty_input_identifier.next().next().next().next().next().fadeOut();
        qty_input_identifier.next().next().next().next().next().next().fadeIn().css("display","inline-block");
        
        window.wwwApi.cart.updateCart(formObject.id, formObject.qty_raw).then(response => {

            cartLine = qty_input_identifier.parent().parent().parent();

            unitPrice = Number(cartLine.attr("data-attr-up")).toFixed(2);
            qty = Number(qty_input_identifier.val()).toFixed(2);
            totalPrice = localeString((unitPrice*qty).toFixed(2));

            cartLine.find('.item-total span').last().text('$'+totalPrice);

            //Update total price

            totalCartPrice = Number(0);
            $(".brand:first-of-type .brand-item").each(function(){
                unitPrice = Number($(this).attr("data-attr-up")).toFixed(2);
                qty = Number($(this).find('.qty-final').prev().val()).toFixed(2);
                linePrice = (unitPrice*qty).toFixed(2);
                totalCartPrice += Number(linePrice);
            });

            
            $('.brand:first-of-type .subtotal strong').text('$'+localeString(totalCartPrice.toFixed(2)));
            qty_input_identifier.next().next().next().next().next().next().fadeOut();
            
            ajaxICDS_cart_discounts();
            ajaxCartLineQty();
        });


    });

       //AJAX FOR DELETE LINE FROM CART
    $(".delete-from-cart-form").each(function(){
         $(this).submit(function(e){
            e.preventDefault();
            var form = $(this);
            window.wwwApi.cart.deleteCart(form.find('input[name="line_pk"]').val()).then((response) => {

                if(response.ok)
                {	
                    if($(".brand:first .brand-item").length == 1)
                    {
                        emptyCart = '<h1>My Cart</h1><div class="empty"><h4>Your cart is currently empty</h4><p>Maybe you\'re looking for some <a href="' + window.appConfig.urls.catalogue + '">products</a>?</p><div class="quick-add-button"><button class="btn btn-primary" type="submit">Quick add item</button></div></div></div>';
                        $(".cart").empty();
                        $(".cart").append(emptyCart);
                        // ajaxUpdateCartDiscount();
                        ajaxICDS_cart_discounts();
                        ajaxCartLineQty();
                    }
                    else
                    {
                        $(form).parent().parent().remove();
                        ajaxICDS_cart_discounts();
                        // ajaxUpdateCartDiscount();
                        ajaxCartLineQty();

                        totalCartPrice = Number(0);

                        $(".brand:first-of-type .brand-item").each(function(){
                            unitPrice = Number($(this).attr("data-attr-up")).toFixed(2);
                            qty = Number($(this).find('.qty-final').prev().val()).toFixed(2);
                            linePrice = (unitPrice*qty).toFixed(2);
                            totalCartPrice += Number(linePrice);
                        });

                        $('.brand:first-of-type .subtotal strong').text('$'+localeString(totalCartPrice.toFixed(2)));
                    }
                    
                }

            });

        });

    });


    //If is cart then run the ajax discounts call

    if (window.location.pathname.indexOf("cart") >= 0 && window.location.pathname.indexOf("address") <= 0)
    {
        ajaxICDS_cart_discounts();
    }

    //If Product Page dispaly Cart Summary
    if (window.location.pathname.indexOf("products") >= 0 || window.location.pathname.indexOf("address") >= 0)
    {
        ajaxMiniCart();
    }

    ajaxCartLineQty();




    //Update Address Selection in Form
    $("form.select-address button").click(function(event){
        event.preventDefault();

        address_id = $(this).attr("data-address");
        $("select.select-address").val(address_id);

        $("form.select-address").submit();

    });

    //Subscript Decimal Places on Product Page
    $("#specs div div p strong").each(function(){
        number = $(this).text().replace(/[^\d.-]/g, '');
        text = $(this).text().replace(".","").replace(/\d+/,'~').split("~");
        decimal_split = number.split(".");

        if(decimal_split.length == 2)
        {	
            if(text.length > 1){prefix = text[0] + ' '; suffix = text[1] + ' ';}
            else if(text.length == 1){suffix = text[0] + ' '; prefix = ''}
            else {prefix = ''; suffix = '';}
            number = decimal_split[0];
            decimal = decimal_split[1];
            new_number = prefix + number + '<sup>' + decimal + '</sup>' + suffix;
            $(this).empty();
            $(this).append(new_number)
        }
    });

    //Align Variants

    // NPV Update

    if($(".new-product-variants").length)
    {
        variant_max_width = 0;
        variant_max_height = 0;
        $(".new-product-variants li button").each(function(){
            if($(this).width() > variant_max_width){variant_max_width = $(this).width()}
            if($(this).height() > variant_max_height){variant_max_height = $(this).height()}
        });	

        $(".new-product-variants li button").width(variant_max_width).height(variant_max_height);
    }
    else
    {
        variant_max_width = 0;
        variant_max_height = 0;
        $("._2018-product-variants .variant-container").each(function(){
            if($(this).width() > variant_max_width){variant_max_width = $(this).width()}
            if($(this).height() > variant_max_height){variant_max_height = $(this).height()}
        });	

        $("._2018-product-variants .variant-container").width(variant_max_width).height(variant_max_height);	
    }

    
    

    // Add padding to any rows with EOL or SO badges
    if($("._2018-product-variants .variant-container .eol-banner").length)
    {
        new_row_items = []
        row_req_padding = []
        cur_row = 0;
        cur_row_offset_top = 0;
        $("._2018-product-variants .variant-container").each(function(index){
            if($(this).offset().top > cur_row_offset_top)
            {
                cur_row_offset_top = $(this).offset().top;
                cur_row++;
                new_row_items.push(index)
            }

            if($(this).find('.eol-banner').length)
            {
                if(row_req_padding.indexOf(cur_row) == -1)
                    row_req_padding.push(cur_row)
            }
        });

        // Apply the padding
        for (var i = 0; i < row_req_padding.length; i++) {
            first_item_index = new_row_items[(row_req_padding[i] - 1)];
            last_item_index = new_row_items[row_req_padding[i]] - 1;

            if(!last_item_index)
            {
                // If it's the end of the row:
                last_item_index = $("._2018-product-variants .variant-container").length;
            }

            $("._2018-product-variants .variant-container").each(function(index){
                if(index >= first_item_index && index <= last_item_index)
                {
                    $(this).css('margin-top','20px');
                }
                
                if(index > last_item_index)
                    return false;
            });
        }

    }


    //Variant Stock Levels
    function updateStockLevels(variant_id, not_for_sale)
    {
        if($.isEmptyObject(variant_stock_levels))
            return

        var display_backorder = true;
        var backorder_eta = '';

        // If both a flag is less than 4 then don't display backorder message, otherwise display it.

        // Check if stocks, if not ignore
        if(variant_stock_levels[variant_id])
        {
            for (var i = variant_stock_levels[variant_id].length - 1; i >= 0; i--) {
                if(variant_stock_levels[variant_id][i]['flag'] < 4)
                {
                    display_backorder = false;
                    break
                }
                else if(variant_stock_levels[variant_id][i]['est_new'])
                {	
                    // Convert Est New to JS Date:
                    mon = variant_stock_levels[variant_id][i]['est_new'].replace(/[0-9]/g, '').replace(/\s/g, '');
                    day = variant_stock_levels[variant_id][i]['est_new'].replace(/\D/g,'').replace(/\s/g, '');
                    eta = new Date(Date.parse(mon +" "+day+", 2012"));

                    if(!backorder_eta)
                    {
                        backorder_eta = eta
                    }
                    else if (eta > backorder_eta)
                    {
                        backorder_eta = eta
                    }
                }
            }
        }
        else
        {
            display_backorder = false;
        }


        if(display_backorder)
        {
            window.display_backorder = true;
            window.backorder_eta = backorder_eta;
        }
        else
        {
            window.display_backorder = false;
            window.backorder_eta = '';
        }
        

        if(not_for_sale)
        {
            if(variant_stock_levels[variant_id])
            {
                for (var i = variant_stock_levels[variant_id].length - 1; i >= 0; i--) {
                     variant_stock_levels[variant_id][i]['flag'] = 5;
                }

            }
        }

        var template = Handlebars.compile($('#product-availability-template').html());

        if(typeof(variant_stock_levels) != "undefined")
        {

            $(".new-product-availability").empty();
            display_leadtime = false;
            min_leadtime = false;
            max_leadtime = false;

            if(variant_id in spo_variants)
            {
                // Check if we should display SPO or stock. Ie item has no stock anywhere.
                in_stock = false;
                for (var i = variant_stock_levels[variant_id].length - 1; i >= 0; i--) {

                    if(variant_stock_levels[variant_id][i]['flag'] <= 3)
                    {	
                        in_stock = true;
                        break;
                    }
                }

                if(!in_stock)
                {
                    display_leadtime = true;
                    let percentage = Math.floor(spo_variants[variant_id] * 0.1);
                    let difference = percentage >= 2 ? percentage : 2;
                    min_leadtime = spo_variants[variant_id]-difference;
                    max_leadtime = spo_variants[variant_id]+difference;
                }
            
            }


            if(variant_stock_levels[variant_id])
            {
                $('.new-product-availability').html(
                    template({
                        stock_levels: variant_stock_levels[variant_id],
                        display_leadtime: display_leadtime,
                        min_leadtime: min_leadtime,
                        max_leadtime: max_leadtime,
                        csrfToken: window.appConfig.csrfToken
                    })
                );
            }
            
        }
        
    }

    //Left of new category navs
    new_nav_margin = $("#sub-nav-1").outerWidth()+4;
    // $(".new-nav-sub-products-menu-wrapper").css('left',new_nav_margin);


    //Left Margin of each nav
    //Logic: For each of the sub nav triggers, get its offset from the left and apply that as the margin-left to the subnav
    navContainerOffset = $(".new-nav").offset().left - 10 -5; //This 10 is to compinsate for the -10px margin-left on the first nav item, this 5px is to compinsate for the 5px padding-left on .new-sub-nav-wrapper

    $(".sub-menu-trigger").each(function(){
        linked_id = '#sub-nav-' + $(this).find('a').attr("data-attr-sub");
        if($(linked_id).length)
        {	
            $(linked_id).css("left",($(this).offset().left - navContainerOffset));
        }
    });

    //Fix issue caused by order product itel being too long and thus pushing the little extended terms icon onto a new line
    
    $(".product-order-title").each(function(){

        if($(this).width() >= ($(this).parent().width()-20) && $(this).next().hasClass('extended-terms'))
        {
            $(this).next().css('margin','5px 0px 0px 0px')
        }
    });


    //Assign the Account Height
    largest_account_body = 0;
    $(".account-body").each(function(){
        if($(this).height() > largest_account_body)
        {
            largest_account_body = $(this).height();
        }
    });
    $(".account-content").height(largest_account_body);

    //New account tabs
    $('.new-account-detail-nav li').click(function(){
        target = "#" + $(this).attr('data-attr-link') + '-panel';
        if($(target).length)
        {	
            $('.new-account-detail-nav ul li').removeClass('active');
            $(this).addClass('active');
            $(".account-body").fadeOut();
            $(target).fadeIn();
        }
    });

    //Get from # or make sure first is active
    if(window.location.hash)
    {	
        //Make all visible attr = true after load

        target = window.location.hash + '-panel';
        if($(target).length)
        {
            $(target).show();
            $('.new-account-detail-nav li[data-attr-link="'+window.location.hash.replace('#','')+'"]').addClass('active');
        }
        else
        {
            $(".account-body:first").show();
            $(".new-account-detail-nav ul li:first").addClass('active');
        }
    }
    else
    {
        //Make all visible attr = true after load
        $(".account-body").css('visibility','visible');

         $(".account-body:first").fadeTo(500, 1).css("z-index","5");
         $(".new-account-detail-nav ul li:first").addClass('active');
    }

    // New Dealer Form - About Char Counter
    if($("#about-textarea-feedback").length)
    {	
        about_required_length = 200
        $("#id_about").on('keyup', function() {

            var about_text_length = $('#id_about').val().length;
            var about_text_remaining = about_required_length - about_text_length;

            if(about_text_remaining > 0)
            {
                $('#about-textarea-feedback span').text(about_text_remaining + ' characters remaining');
            }
            else
            {
                $('#about-textarea-feedback span').text(' ');
            }

        });
    }

    

// 	//Add email to footer
// 	$("footer div span:last-of-type, footer div span:first-of-type").append('<'+'a'+' '+'h'+'r'+'e'+'f'+'='+"'"+'m'+'&'+'#'+'9'+'7'+';'+'i'+'l'+'t'+'&'+'#'+'1'+'1'+'1'+';'+'&'+
// '#'+'5'+'8'+';'+'s'+'a'+'l'+'e'+'s'+'&'+'#'+'6'+'4'+';'+'&'+'#'+'1'+'0'+'5'+';'+'n'+'t'+'e'+'r'+'d'+'y'+'&'+'#'+'1'+'1'+'0'+';'+'&'+'#'+'4'+
// '6'+';'+'c'+'o'+'m'+'&'+'#'+'4'+'6'+';'+'a'+'&'+'#'+'1'+'1'+'7'+';'+"'"+'>'+'s'+'a'+'l'+'e'+'s'+'&'+
// '#'+'6'+'4'+';'+'&'+'#'+'1'+'0'+'5'+';'+'n'+'t'+'e'+'r'+'d'+'y'+'&'+'#'+'1'+'1'+'0'+';'+'&'+'#'+'4'+
// '6'+';'+'c'+'o'+'m'+'&'+'#'+'4'+'6'+';'+'a'+'&'+'#'+'1'+'1'+'7'+';'+'<'+'/'+'a'+'>');


ProductBlockHeightStandardise();
 
window.lowest_level = 0;
$('.sub-sub-menu-trigger').each(function(){
    sub_nav_id = '#sub-sub-nav-' + $(this).find('a').attr('data-attr-sub');
    if($(sub_nav_id).length)
    {	
        class_list = null;
        class_list = $(sub_nav_id).attr('class').split(/\s+/);
        $.each(class_list, function(index, item) {
            if ((item.indexOf('level') > -1)) {
                target_level_int = parseInt(item.replace('level-',''));
                if(target_level_int > window.lowest_level)
                {
                    window.lowest_level = target_level_int;
                }
            }
        });
    }
});

//Define variable of inital close wrapper width
window.closeWrapperInitialWidth = $('.new-nav-close-wrapper').width();
window.closeWrapperInitialHeight = $('.new-nav-close-wrapper').height();
window.closeWrapperDefaultWidth = 0;
window.closeWrapperDefaultHeight = 0;
window.closeWrapperDefaultLeft = -20;

function closeContainerResize()
{
    $(".new-nav-close-container").height($('.new-nav-close-wrapper').height()).width($('.new-nav-close-wrapper').width()).css("left",parseInt($('.new-nav-close-wrapper').css("left"))+10);
}

//New Nav Scripts
$('li.sub-menu-trigger a').click(function(e){

    e.preventDefault();
    //Show the close wrapper
    $(".new-nav-close-wrapper").show();

    sub_nav_id = '#sub-nav-' + $(this).attr('data-attr-sub');
    
    $(".new-sub-nav-sidebar").slideUp();
    $(".new-nav-close-wrapper").width(window.closeWrapperInitialWidth);
    $(".new-nav-close-wrapper").height(window.closeWrapperInitialHeight);
    $(".new-nav-close-wrapper").css("left",0);
    closeContainerResize();


    //Close all further target levels
    for (var i = window.lowest_level; i > 1; i--) {
        $('.level-'+i).parent().width(0);
        $('.level-'+i+" .sub-sub-menu-trigger.active").removeClass("active");
    }

    $(".level-1 .sub-sub-menu-trigger.active").removeClass("active");

    if($(sub_nav_id).length)
    {	
        if($(sub_nav_id).is(":visible"))
        {
            $(sub_nav_id).slideUp();
            window.closeWrapperDefaultWidth = 0;
            window.closeWrapperDefaultHeight = 0;

            //Hide the close wrapper
            $(".new-nav-close-wrapper").hide();
            
            $(".new-nav-close-wrapper").width(window.closeWrapperInitialWidth);
            $(".new-nav-close-wrapper").height(window.closeWrapperInitialHeight);
            $(".new-nav-close-wrapper").css("left",window.closeWrapperDefaultLeft);
            closeContainerResize();
        }
        else
        {
            $(sub_nav_id).slideDown(400 , function() {
                $(".new-nav-close-wrapper").width($(".new-nav-close-wrapper").width() + $(sub_nav_id).outerWidth());
                $(".new-nav-close-wrapper").height($(".new-nav-close-wrapper").height() + $(sub_nav_id).outerHeight());
                new_left = parseInt($(sub_nav_id).css("left")) - 20;
                $(".new-nav-close-wrapper").css("left", new_left);
                


                window.closeWrapperDefaultWidth = $(".new-nav-close-wrapper").width();
                window.closeWrapperDefaultHeight = $(".new-nav-close-wrapper").height();
                window.closeWrapperDefaultLeft = parseInt($(sub_nav_id).css("left")) -20;
                closeContainerResize();
             });
            
        }
        
    }
    
});

$('.new-nav-close-wrapper').mouseenter(
function(){
    continue_close = true;

    $('.new-nav-sub-products-menu-wrapper').each(function(){
        if($(this).width() > 0)
        {
            continue_close = false
        }
    });

    if(continue_close)
    {
        $(".new-sub-nav-sidebar").slideUp();
    }

    $(".new-sub-nav-sidebar").slideUp();

    //Hide the close wrapper
    $(".new-nav-close-wrapper").hide();

    $(".new-nav-close-wrapper").width(closeWrapperInitialWidth).height(closeWrapperInitialHeight).css("left",0);
    closeContainerResize();
});

$('li.sub-sub-menu-trigger a').click(function(e){

    sub_nav_id = '#sub-sub-nav-' + $(this).attr('data-attr-sub');
    if($(sub_nav_id).length)
    {
        //If open remain open
        if($(sub_nav_id).parent().width() == 0)
        {
            e.preventDefault();

            target_level = null;

            class_list = $(sub_nav_id).attr('class').split(/\s+/);
            $.each(class_list, function(index, item) {
                if ((item.indexOf('level') > -1)) {
                    target_level = item;
                    target_level_int = parseInt(item.replace('level-',''));
                }
            });

            //Close all further target levels
            for (var i = window.lowest_level; i >= target_level_int; i--) {

                    $('.level-'+i).parent().animate({width:0}, { duration: 500, queue: false });
                    $('.level-'+i+" .sub-sub-menu-trigger.active").removeClass("active");
                
            }

            //Remove active on this level
            $(this).parent().parent().find('.active').removeClass('active');



            //If level is greater than 2 then calculate the margin left
            if(target_level_int > 2)
            {
                prior_target_class = String('.level-'+ parseInt(target_level_int-1));
                new_level_margin_left = $(this).parent().parent().parent().width() + $(prior_target_class).parent().width() - 13;
                $('.'+target_level).parent().css('left',new_level_margin_left);
            }

            //Remove any open sub menus from the close wrapper width + height
            $('.new-nav-close-wrapper').width(window.closeWrapperDefaultWidth);
            $('.new-nav-close-wrapper').height(window.closeWrapperDefaultHeight);
            $('.new-nav-close-wrapper').css("left",window.closeWrapperDefaultLeft);
            closeContainerResize();

            $(this).addClass('active');
            $(sub_nav_id).show();

            // I hate DOM manipulation
            const currentMenuLeft = parseInt($(this).parent().parent().parent().css('left'));
            $(sub_nav_id).parent().css('left', currentMenuLeft + $(this).parent().parent().parent().width() + 35);

            $(sub_nav_id).parent().animate({width:$(sub_nav_id).width()+35, duration: 500, queue: false}, 500, function() {

                $(".new-nav-close-wrapper").width($(".new-nav-close-wrapper").width() + $(sub_nav_id).parent().outerWidth());
                closeContainerResize();

                if($(sub_nav_id).parent().outerHeight() > $(".new-nav-close-wrapper").outerHeight())
                {
                    $(".new-nav-close-wrapper").height($(sub_nav_id).parent().outerHeight());
                }
            });
        }

        
    }

});

$(".account-button a").click(function(e){
    
    if(!$(this).parent('.account-button').hasClass("active"))
    {
        e.preventDefault();
        $('.new-account-nav').slideToggle();
        $(this).parent('.account-button').toggleClass("active");
    }
    
});

$('.new-account-nav').hover(
function(){
},
function () {
    $(this).slideUp();
    $(".account-button").toggleClass("active");
});



function animateHomeOffersController(container)
{
    total_offers = $(".offer-"+container+"-container .offer").length -1;
    current_offer = 0;
    prev_offer = total_offers;

    $(".offer-"+container+"-container .offer:eq("+prev_offer+")").fadeOut();
    $(".offer-"+container+"-container .offer:eq("+current_offer+")").fadeIn();

    setInterval(function(){

        if(current_offer == total_offers)
        {
            current_offer = 0;
            prev_offer = total_offers;
        }
        else
        {
            current_offer++;
            prev_offer = current_offer - 1;
        }

        $(".offer-"+container+"-container .offer:eq("+prev_offer+")").fadeOut();
        $(".offer-"+container+"-container .offer:eq("+current_offer+")").fadeIn();

    }, 4000);
}


$(".catalogue-sort").change(function(){
    window.location.href = $(this).val();
});

// //Open quick add form
$(document).on('click', '.quick-add-button button', function () {
    $('.lightbox-cover').fadeIn();
    $('.lightbox.quick-add-form').fadeIn();
    $("#id_search_typeahead").focus();
});

$(document).on('click', '.quick-add-button-mobile button', function () {
    $('.lightbox-cover').fadeIn();
    $('.lightbox.quick-add-form').fadeIn();
});


window.imageExpanded = false;

//Start large image gallery
function expandImage()
{	
    if(window.imageExpanded)
    {	
        // $(".new-product-info-box-wrapper").animate({'width': "36%"});
        // $(".new-product-info-box").fadeIn();
        // $(".new-product-gallery").animate({'width': "60%", 'height': '350px'}, function(){ $(".new-product-info-box").width('100%');});
        window.imageExpanded = false;		 

        // 2020 Changes
        $(".new-product-gallery-wrapper").animate({'width': "62%"});
        document.querySelector('.new-product-gallery-wrapper').classList.remove('expanded');

    }
    else
    {	
        // $(".new-product-info-box-wrapper").animate({'width': "5%"});
        // $(".new-product-info-box").width($(".new-product-info-box").width()).fadeIn();
        // $(".new-product-info-box").fadeOut();
        // $(".new-product-gallery").animate({'width': "90%", 'height': '500px'});
        window.imageExpanded = true;

        // 2020 Changes

        $(".new-product-gallery-wrapper").animate({'width': "100%"});
        document.querySelector('.new-product-gallery-wrapper').classList.add('expanded');
    }

}

document.querySelectorAll(
    '.new-product-image-expand-button, .new-product-gallery-image-container, .info-box-nav-button'
).forEach((el) => {
   el.addEventListener('click', (ev) => {
      if (!!ev.target.dataset.newTab) {
        window.open(ev.target.src, '_blank');
      } else {
          expandImage();
      }
   });
});





//Set info-box-container height to info-box height
$(".info-box-container .info-box").each(function(){
    $(this).parent().height($(this).outerHeight()+30);
});


// Recent News Ready Scripts
$(".nt-close").click(function(){
        
    // Force the rows to fixed heights so the animation operates.
    if($(".news-ticker").hasClass('closed'))
    {
        $(".news-ticker .nt-row").each(function(){

            $(this).css("height",$(this).attr('data-attr-height'));
        });
    }

    $(".news-ticker").toggleClass('closed');

    $(".news-ticker").addClass('user-toggled');


});

// Blog Reactions Scripts
$('body').on('click', '.post-recations .reaction', function ()
{
    if(window.can_react)
    {
        if(!$(this).hasClass('reacted') && !$(this).hasClass('rc'))
        {	
            reaction_uuid = $(this).attr('data-attr-uuid')
            reaction_el = $(this);
            $.ajax({
            type: 'GET',
            url: window.location.href + 'react/' + reaction_uuid,
            }).done(function(response) {

                if('reacted' in response && 'count' in response)
                {
                    reaction_el.addClass('reacted');
                    reaction_el.next().text(response.count).addClass('reacted');
                }

            });
            
        }
    }
    
});


// News Ticker Reaction Scripts
$('body').on('click', '.nt-reacts .react', function ()
{

    if(!$(this).hasClass('reacted') && !$(this).hasClass('rc'))
    {	
        post_url = $(this).attr('data-attr-post-u');
        reaction_uuid = $(this).attr('data-attr-uuid');
        reaction_el = $(this);
        a_url = post_url + 'react/' + reaction_uuid;
        $.ajax({
        type: 'GET',
        url: a_url,
        }).done(function(response) {

            if('reacted' in response && 'count' in response)
            {
                reaction_el.addClass('reacted');
                reaction_el.find('span:last').text(response.count);
            }

        });
        
    }
    
    
});


if(typeof show_post_reactions != 'undefined' && show_post_reactions)
{
    initiateBlogPostReactions();
}

window.itester = 0;

// Blog Ellisips
$(".blog-post").each(function(){

    $("#blog").append('<p style="font-size: 13px; text-overflow: ellipsis; color: #606060; overflow: hidden; opacity: 0; width: 430px;" id="js-calc-para"></p>');

    bpfc = $(this).find('.blog-post-flex-container');
    pt = $(this).find('.post-title');
    text_height = bpfc.height() + bpfc.offset().top - pt.offset().top - pt.height();

    raw_text = $(this).find('.post-short-text').text();
    raw_words = raw_text.split(' ');
    
    char_count = raw_words[0].length;

    $("#js-calc-para").text(raw_words[0]);
    ended = false;

    for (var i = 1; i < raw_words.length; i++) {
        
        update_text = $("#js-calc-para").text() + ' ' + raw_words[i];
        $("#js-calc-para").text(update_text);

        if($("#js-calc-para").height() > text_height)
        {
            ended = true;
            // Remove previous word
            char_count -= (raw_words[i-1].length + 1);
            break
        }
        

        char_count += (raw_words[i].length + 1); // 1 is for space
        
    }

    if(ended)
    {	
        append_text = raw_text.substring(0, char_count) + '...';
        $(this).find('.post-short-text').text(append_text);
    }

    window.itester++;
    

    if(window.itester !==6)
    {	$("#js-calc-para").remove();}
    else
    {	return false;}


    


});




VerticallyAlignProductInfo();
footerOffset();
HomeOfferHeight();
checkRecentNewsOpenClose();


});

//Make sure the height of the home offers are the same height as the Product Spotlight
function HomeOfferHeight()
{
    $(".specials .offer").height($(".best-sellers .product-block:first").outerHeight()-1);
    $(".specials .offer-container:nth-of-type(even)").css('top',String($(".best-sellers .product-block:first").outerHeight()-1+parseInt($(".best-sellers .product-block:first").css('margin-bottom'))+parseInt($(".offer-container:first").css('top')))+'px')
}

//Check if variant height is more than 3 rows, if so add to height of container
function VerticallyAlignProductInfo()
{
    return 
    hidden_dealer_price_margin = $(".dealer-price").is(":hidden") ? 31 : -20;
    if($(".new-product-variants").length)
    {
        $('.new-product-info-box-wrapper').height(330 + $(".new-product-variants").height() - hidden_dealer_price_margin);
    }
    else
    {
        $('.new-product-info-box-wrapper').height(330 + $("._2018-product-variants").height() - hidden_dealer_price_margin);
    }

    if($(".whole-product-eol-box").length)
    {
        $('.new-product-info-box-wrapper').height($('.new-product-info-box-wrapper').height()+$(".whole-product-eol-box").height()+15)
    }
    

    if($(".new-product-info-box-wrapper").height() > $(".new-product-gallery").height())
    {
        $(".new-product-gallery").height($(".new-product-info-box-wrapper").height());
    }

    if ($(".spo-order-eta").length)
    {
        $('.new-product-info-box-wrapper').height($('.new-product-info-box-wrapper').height()+$(".spo-order-eta").height() + 15 - hidden_dealer_price_margin)
    }

}


//Make sure footer is on or below the bottom of the page
function footerOffset()
{	
    return;
    // bottomOffset = $(window).height() - $('footer').offset().top - $('footer').height();

    // if(bottomOffset > 0)
    // {
    //     $("footer").css("position","absolute");
    // }
}

$(window).on('resize', function(){
    //productBlockInstall();
    ProductBlockHeightStandardise();
    VerticallyAlignProductInfo();
    footerOffset();
    popupClosePosition();

    checkRecentNewsOpenClose();
});




// Functions for the Recent News Ticker

// Firstly lets adjust the height to the nearest element
function initiateRecentNews(start_open, offset_top)
{
    return;
    $(".news-ticker").removeClass('pre-initiation');

    // Add Data Height info to make animations work later on
    $(".news-ticker .nt-row").each(function(){
        $(this).attr("data-attr-height",$(this).height());
    });

    if(!start_open)
    {
        $(".news-ticker").addClass('closed');
        $(".news-ticker").css({"top":offset_top});
    }
    else
    {
        // Set the heights here too so the animations work
        $(".news-ticker .nt-row").each(function(){
            $(this).css("height",$(this).attr('data-attr-height'));
        });


        // If home and page is too small lets move the home out of the way
        if($(".home").length)
        {
            if($(window).width() <= 1640)
            {	
                $(".home").css({'position':'absolute','left':$(".home").offset().left,'transition':'left ease 1s'})

                new_left = 'calc('+$("#site-container").offset().left+'px + 0.9375rem)';

                $(".home").css({'left': new_left, 'width':'925px'});
            }

            $(".news-ticker").css({"top":offset_top+15});

        }
        else
        {
            $(".news-ticker").css({"top":offset_top});
        }	
    }

    window.recentNewsInitiated = true;
    window.recentNewsInitiating = false;

}

function toggleOpenCloseRecentNews(open)
{	
    // Stop this script if a user has manually opened or closed the blog
    if (window.recentNewsInitiated && $(".news-ticker").hasClass('user-toggled')) {
        // pass
    }
    else
    {
        if(open && $(".news-ticker").hasClass('closed'))
        {
            $(".news-ticker").removeClass('closed');
        }
        else if(!open && !$(".news-ticker").hasClass('closed'))
        {
            $(".news-ticker").addClass('closed');
        }
    }

    
    if($(".news-ticker").hasClass('closed'))
    {
        currently_open = false;
    }
    else
    {
        currently_open = true;
    }

    if($(".home").length && currently_open)
    {
        if($(window).width() <= 1640)
        {
            $(".home").css({'position':'absolute','left':$(".home").offset().left,'transition':'left ease 1s'})
            new_left = 'calc('+$("#site-container").offset().left+'px + 0.9375rem)';
            $(".home").css({'left': new_left, 'width':'925px'});
        }
        else
        {
            // left is going to be (page width - 970)/2
            $(".home").css({'left':(($(window).width() - 970)/2), 'width':'auto'});
        }
        
    }

    else if($(".home").length && !currently_open)
    {
        // left is going to be (page width - 970)/2
        $(".home").css({'left':(($(window).width() - 970)/2), 'width':'auto'});
    }




}


function checkRecentNewsOpenClose() {
    
    if(!window.recentNewsInitiated && window.recentNewsInitiating)
        // Stop this function firing twice
        return

    if(!window.recentNewsInitiated)
        window.recentNewsInitiating = true;


    // Attempt to find the row with the main content
    window.content_row = false;
    window.news_ticker_top = 0;

    // Custom Script for Home
    if($(".home").length)
    {
        // Home can be resized to a min of 925px, so if 935px + 20 + 300 is less than the page width then its good. So lets set content_furthest_right to 935+container left to evaulate this
        window.content_furthest_right = 935;
        window.news_ticker_top = $(".home").offset().top
    }
    else
    {
        $(".row").each(function(){

            cancel_row = false;

            if($(this).hasClass('messages') || $(this).find('.crumbs').length > 0 || $(this).hasClass('content-header'))
                cancel_row = true;

            if(!cancel_row)
            {
                window.content_row = $(this);
                window.news_ticker_top = $(this).offset().top;
                return false;
            }

        });


        // Check right most element in window.content_row
        window.content_furthest_right = 0;
        window.content_row.find('div').each(function(){

            if($(this).attr('class') && $(this).attr('class').indexOf('col-') == -1)
            {
                right = $(this).offset().left + $(this).width();

                if(right > window.content_furthest_right)
                {
                    window.content_furthest_right = right;
                    // window.testing_123 = $(this).attr('class');
                }
            }

        });
    }

    

    if(!window.recentNewsInitiated)
    {
        //Content Right + News + a bit of space
        if((window.content_furthest_right + 300 + 20) < $(window).width())
        {	
            populateRecentNews(true, window.news_ticker_top);
        }
        else
        {	
            populateRecentNews(false, window.news_ticker_top);
        }
    }
    else
    {
        //Content Right + News + a bit of space
        if((window.content_furthest_right + 300 + 20) < $(window).width())
        {
            toggleOpenCloseRecentNews(true);
        }
        else
        {
            toggleOpenCloseRecentNews(false);
        }
    }
}

function checkImagesLoaded(start_open, offset_top)
{	
    loaded_count = 0;
    img_count = $(".nt-image").length;
    $(".nt-image").each(function(){
        
        loaded = true;

        if (!$(this)[0].complete) {
            loaded = false;
        }

        if ($(this)[0].naturalWidth === 0) {
            loaded = false;
        }

        if(loaded)
            loaded_count++;
    });

    if(loaded_count == img_count)
    {
        initiateRecentNews(start_open, offset_top);
    }
    else
    {
        setTimeout(function(){checkImagesLoaded(start_open, offset_top);}, 300);
    }
}

function populateRecentNews(start_open, offset_top){

    if('blog' in window.appConfig.urls)
    {
        $.ajax({
        type: 'GET',
        url: window.appConfig.urls.blog + 'recent-news/',
        }).done(function(response) {

            if('posts' in response)
            {	
                if('title' in response && response.title)
                {
                    $(".news-ticker .nt-header span").text(response.title);
                }

                if('title_color' in response && response.title_color)
                {
                    $(".news-ticker .nt-header span").css('color', response.title_color);
                }

                if('ticker_arrow_colour' in response && response.ticker_arrow_colour)
                {	
                    if(response.ticker_arrow_colour == 'rainbow')
                    {
                        $(".news-ticker .nt-close").addClass('rainbow');
                    }
                    else
                    {
                        $(".news-ticker .nt-close").css('background-color', response.ticker_arrow_colour);
                    }
                }

                $(".nt-row-container").empty();

                for (var i = 0; i < response.posts.length; i++) {

                    post = '<div class="nt-row">';
                    post += '<div class="nt-small-header">';
                    post += 	'<span>'+ response.posts[i].title_closed + '</span>';
                    post += '</div>';
                    post += '<div class="nt-content">';
                    post += '<span class="nt-title">'+ response.posts[i].title + '</span>';
                    
                    if('image' in response.posts[i] && response.posts[i].image)
                    {	
                        if(response.posts[i].link_text && response.posts[i].link_url)
                        {
                            post += '<a href="' + response.posts[i].link_url + '"';

                            if(response.posts[i].external_link)
                            {
                                post += ' target="_blank"'
                            }

                            post += '>';
                        }

                        post += '<img class="nt-image" src="' + response.posts[i].image + '">';

                        if(response.posts[i].link_text && response.posts[i].link_url)
                        {
                            post += '</a>';
                        }
                    }
                    post += '<p class="nt-text">'+ response.posts[i].content + '</p>';
                            
                        if(response.posts[i].link_text && response.posts[i].link_url)
                        {
                            post += '<a href="' + response.posts[i].link_url + '" class="nt-link"';

                            if(response.posts[i].external_link)
                            {
                                post += ' target="_blank"'
                            }

                            post += '>' + response.posts[i].link_text + '</a>';
                        }
                    
                    if(response.posts[i].reacts['reactions'].length)
                    {
                        post += '<div class="nt-reacts-wrapper"> <div class="nt-reacts">';
                    }

                    for (var react_i = 0; react_i < response.posts[i].reacts['reactions'].length; react_i++) {
                        

                        post += '<div data-attr-post-u="'+ response.posts[i].url +'" class="react';

                        if(response.posts[i].reacts['reactions'][react_i].reacted)
                            post += ' reacted';

                        if(!response.posts[i].reacts.can_react)
                            post += ' rc';

                        post += '" data-attr-uuid="'+ response.posts[i].reacts['reactions'][react_i].uuid +'">';

                        if(response.posts[i].reacts['reactions'][react_i].fa)
                            {post += '<span class="fa fa-'+response.posts[i].reacts['reactions'][react_i].fa+'"></span>';}
                        else
                            {
                            post += '<div class="reaction-image" style="background-image: url(\''+response.posts[i].reacts['reactions'][react_i].image+'\');"></div>';
                        }

                        post += '<span>'+ response.posts[i].reacts['reactions'][react_i].count +'</span>';
                        post += '</div>';
                    }

                    if(response.posts[i].reacts['reactions'].length)
                    {
                        post += '</div></div>';
                    }


                    post += '</div>';
                    post += '</div>';

                    $(".nt-row-container").append(post);

                }

                if(response.posts.length)
                {
                    // Delay to allow images to load

                    checkImagesLoaded(start_open, offset_top);
                    
                }

            }

            

        });
    }
    
}


function initiateBlogPostReactions(){

    $.ajax({
        type: 'GET',
        url: window.location.href + 'reactions',
    }).done(function(response) {

        window.can_react = false;
        if ('can_react' in response)
        {
            if(response.can_react == true)
                window.can_react = true;
        }

        if('reactions' in response)
        {
            $(".post-recations").empty();

            if(response.reactions.length)
            {
                if(window.can_react)
                    $(".post-recations").append('<span class="post-share-title">React</span>');
                else
                    $(".post-recations").append('<span class="post-share-title">Reactions</span>');
            }
            

            for (var i = 0; i < response.reactions.length; i++) {
                response.reactions[i]
                reaction = '<div class="reaction';

                if(response.reactions[i].reacted)
                    reaction += ' reacted';

                if(!window.can_react)
                    reaction += ' rc';

                reaction += '" data-attr-uuid="'+ response.reactions[i].uuid +'">';
                
                if(response.reactions[i].fa)
                    {reaction += '<span class="fa fa-'+ response.reactions[i].fa +'"></span>';}
                else
                {
                    reaction += '<div class="reaction-image" style="background-image: url(\''+response.reactions[i].image+'\');"></div>';
                }
                reaction += '</div>';
                reaction += '<span class="reaction-count';

                if(response.reactions[i].reacted)
                    reaction += ' reacted';

                reaction += '">'+response.reactions[i].count+'</span>';
            
                $(".post-recations").append(reaction);
            }
        }

    });
    
}



/*! Bootstrap Carousel Swipe jQuery plugin v1.1 | https://github.com/maaaaark/bcSwipe | MIT License */
!function(t){t.fn.bcSwipe=function(e){var n={threshold:50};return e&&t.extend(n,e),this.each(function(){function e(t){1==t.touches.length&&(u=t.touches[0].pageX,c=!0,this.addEventListener("touchmove",o,!1))}function o(e){if(c){var o=e.touches[0].pageX,i=u-o;Math.abs(i)>=n.threshold&&(h(),t(this).carousel(i>0?"next":"prev"))}}function h(){this.removeEventListener("touchmove",o),u=null,c=!1}var u,c=!1;"ontouchstart"in document.documentElement&&this.addEventListener("touchstart",e,!1)}),this}}(jQuery);
$('.carousel').bcSwipe({ threshold: 50 });


// COMMENTED TOUR SCRIPTS
/*
function joyride_end()
{
    $(".tutorial-icon").removeClass("active");
}

function joyride_kill()
{
    if($('.joyride-tip-content'))
    {
        $.fn.joyride('destroy')
    }

    //Reset cookie value
    $.cookie("interdyn_tour", 0, { path: '/' });
    
}


function check_next_tour()
{

    if($('.joyride-tip-content'))
    {
        $.fn.joyride('destroy')
    }


    //Check what page is open to show relevent tour part
    if($("#joyride-catalogue").length)
    {	
        $('#InterdynJoyrideTour-catalogue').joyride({
            autoStart: true,
            postRideCallback: function () {
                joyride_end();
            },
            modal: false,
            expose: true
        });

        $(".tutorial-icon").addClass("active");
    }

    if($("#joyride-product-detail").length)
    {
        $('#InterdynJoyrideTour-product-detail').joyride({
            autoStart: true,
            postRideCallback: function () {
                joyride_end();
            },
            modal: false,
            expose: true
        });

        $(".tutorial-icon").addClass("active");
    }


    if($("#joyride-cart").length)
    {
        $('#InterdynJoyrideTour-cart').joyride({
            autoStart: true,
            postRideCallback: function () {
                joyride_kill();
                joyride_end();
            },
            modal: false,
            expose: true
        });

        $(".tutorial-icon").addClass("active");

    }
}


$(window).load(function() {

    //Trigers to load joy-rides

    // if($("#joyride-nav").length)
    // {
    // 	$('#InterdynJoyrideTour-home').joyride({
 //            'tipLocation': 'top',
 //            autoStart: true,
 //            postRideCallback: function () {
 //                joyride_end();
 //            },
 //            modal: false,
 //            expose: true
 //        });

    // 	$(".tutorial-icon").addClass("active");
    // }

    // if($("#joyride-catalogue").length)
    // {
    // 	$('#InterdynJoyrideTour-catalogue').joyride({
    // 		autoStart : true,
    // 	});

    // 	$(".tutorial-icon").addClass("active");
    // }

    // if($("#joyride-product-detail").length)
    // {
    // 	$('#InterdynJoyrideTour-product-detail').joyride({
    // 		autoStart : true,
    // 	});

    // 	$(".tutorial-icon").addClass("active");
    // }


    // if($("#joyride-cart").length)
    // {
    // 	$('#InterdynJoyrideTour-cart').joyride({
 //            autoStart: true,
 //            postRideCallback: function () {
 //                $('#InterdynJoyrideTour-cart').joyride('destroy');
 //            },
 //            modal: false,
 //            expose: true
 //        });
 //        $(".tutorial-icon").addClass("active");

    // }

    // $(".tutorial-icon").click(function()
    // {
    // 	if(!$(this).hasClass("active"))
    // 	{
    // 		$('#InterdynJoyrideTour-home').joyride({
    // 			autoStart : true,
    // 		});
    // 		$(".tutorial-icon").addClass("active");
    // 	}
    // });
    
});

*/

module.exports = { ajaxAddToCart };

}.call(window));